<template>

    <!-- [ Header ] start -->
    <div class="header" :class="{ subscription: $route.name === 'subscriptions' }">
        <!--{{myFirstCompanys}}-->
        <!-- [ Select Company ] start -->
        <div class="company">
<!--            {{getStateId}}-->


            <!-- TODO: -->
            <your-organization-drop-down class="organisation-dropdown">
                <template #button>
                    <div>
                        <!-- [ BTN Menu ] start -->
                        <div v-if="!sidebarOpened" class="hamburger">
                            <div class="hamburger__item"></div>
                            <div class="hamburger__item"></div>
                            <div class="hamburger__item"></div>
                        </div>
                        <!-- [ BTN Menu ] end -->
                        <!-- [ BTN Menu close ] start -->
                        <div v-if="sidebarOpened" id="close">
                            <span class="close"></span>
                        </div>
                    </div>
                </template>
            </your-organization-drop-down>

            <el-dropdown placement="top-start">
              <div class="company__name">
                <div class="logo">
                    <img class="logo_img" src="../../assets/img/o.png" height="20px">
                </div>
                <div v-html="activeCompanyName" style="font-size: 16px; cursor: pointer;"></div>
              </div>
              <el-dropdown-menu slot="dropdown" placement="bottom-end">
                <div>
                  <el-dropdown-item
                      v-for="companie in user.companyList"
                      :key="companie.id"
                      @click.native="setCompany(companie)">
                    <div v-if="companie.isOwnCompany" class="circle circle__green"></div>
                    <div v-else class="circle circle__grey"></div>
                    {{companie.name}}
                  </el-dropdown-item>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <el-tooltip
                v-if="getSubscription && getSubscription.status === 'trial'"
                :content="`Your Trial Period Expires ${moment(getSubscription.endDate, 'X').format(`ddd DD MMM 'YY`)}`"
                placement="bottom"
                effect="light">
              <i class="el-icon-warning warning-icon"></i>
            </el-tooltip>
        </div>
        <el-dropdown trigger="click" placement="top-start" @visible-change="setHelpVisible">
          <div class="my-workday">
            Help
          </div>
          <el-dropdown-menu slot="dropdown" placement="bottom-end" style="width: 210px;">
            <el-dropdown-item v-for="(item, index) in helpList" :command="item.id" :key="index" @click.native="() => setHelp({ ...item})">
              {{item.title}}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div
            class="my-workday"
            @click="routerLink('account-think')">
            TF Accounting
        </div>
        <el-dropdown placement="top-start" @command="setWorkday">
            <div class="my-workday">
                <i class="el-icon-tickets"></i>
                <span style="margin-left:5px;">
                    {{$t('header_myWorkday')}}
                </span>
            </div>
            <el-dropdown-menu slot="dropdown" placement="bottom-end" style="width: 210px;">
                <el-dropdown-item command="businessUnit">
                    {{$t('header_myWorkday_businessUnit')}}
                </el-dropdown-item>
                <el-dropdown-item disabled command="warehouse">
                    Warehouse
                </el-dropdown-item>
                <el-dropdown-item command="engagement">
                    {{$t('header_myWorkday_engagement')}}
                </el-dropdown-item>
                <el-dropdown-item command="project">
                    {{$t('header_myWorkday_project')}}
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>

        <support-dropdown/>
<!--        <el-dropdown placement="top-start">-->
<!--          <div class="feedback">-->
<!--            <img src="@/assets/img/toolbar/support_icn.svg" width="18px" alt="" style="margin-right: 5px;">-->
<!--            {{$t('menu_support')}}-->
<!--          </div>-->
<!--          <el-dropdown-menu slot="dropdown" placement="bottom-end" style="width: 210px;">-->
<!--            <el-dropdown-item disabled>-->
<!--              {{$t('modal_feedback_reachout')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="selectedFeedback(2)">-->
<!--              <i class="fas fa-exclamation-triangle"></i>-->
<!--              {{$t('modal_feedback_error')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="selectedFeedback(3)">-->
<!--              <i class="fas fa-question-circle"></i>-->
<!--              {{$t('modal_feedback_help')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="selectedFeedback(1)">-->
<!--              <i class="fas fa-thumbs-up"></i>-->
<!--              {{$t('modal_feedback_feedback')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="selectedFeedback(4)">-->
<!--              <i class="fas fa-comment-dots"></i>-->
<!--              {{$t('modal_feedback_enquiries')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item @click.native="selectedFeedback(5)">-->
<!--              <i class="fas fa-calculator"></i>-->
<!--              {{$t('modal_feedback_accounting_issues')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item disabled>-->
<!--              {{$t('modal_feedback_explore')}}-->
<!--            </el-dropdown-item>-->
<!--            <el-dropdown-item-->
<!--              v-for="item in supportPage"-->
<!--              :key="item.id"-->
<!--              @click.native="supportPageClick(item.url)"-->
<!--              :disabled="!item.url">-->
<!--              {{item.name}}-->
<!--            </el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
        <!--notificetion-tab: {{activeNotiTab}}-->
        <!--next-page: {{nextPage}}-->
        <!--notification-id: {{notificationId}}-->
        <div class="my-lists">
            <div @mouseenter="getList('list')" class="notification__item">
                <el-dropdown>
                    <el-badge :value="0" hidden class="item">
                        <el-button size="small">
                            <img src="@/assets/img/toolbar/stack.svg" width="18px" alt="">
                        </el-button>
                    </el-badge>
                    <el-dropdown-menu slot="dropdown">
                        <el-tabs v-model="activeListTab" stretch class="parent-notification-tabs">
                            <el-tab-pane :label="$t('header_bu')" name="businessUnits" class="business-units">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="engagements" class="engagements">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="projects" class="prjects">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <div v-if="activeListTab === 'businessUnits'">
                                <div v-if="myBusinessUnitList.length !== 0">
                                    <el-dropdown-item v-for="item in myBusinessUnitList" :key="item.id" style="display: flex; justify-content: space-between">
                                      <div
                                          style="flex:2; max-width: 50%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                          @click="setToPointDep(item.companyId, item.id)" >
                                        {{item.name}}
                                      </div>
                                      <div style="flex:1;">
                                        <el-button
                                            type="primary"
                                            plain
                                            size="mini"
                                            @click="setToPointDep(item.companyId, item.id, 'businessUnitEngagementsTab')">
                                          {{$t('general_view')}}
                                        </el-button>
                                      </div>
                                      <div>
                                        <el-button
                                            style="margin-right: 4px;"
                                            type="primary"
                                            plain
                                            size="mini"
                                            @click="setToPointDep(item.companyId, item.id, 'businessUnitProjectsTab')">
                                          {{$t('general_view')}}
                                        </el-button>
                                      </div>
                                    </el-dropdown-item>
                                </div>
                                <div v-else>
                                    <el-dropdown-item disabled class="empty-head"><span>{{$t('header_no_bu')}}</span></el-dropdown-item>
                                </div>
                            </div>
                            <div v-if="activeListTab === 'projects'">
                                <div v-if="myProjectList.length !== 0">
                                    <el-dropdown-item v-for="item in myProjectList" :key="item.id"><div  @click="setToPointProj(item.companyId, item.id, 'projectInfoTab')" >{{item.name}}</div></el-dropdown-item>
                                </div>
                                <div v-else>
                                    <el-dropdown-item disabled class="empty-head"><span>{{$t('header_no_project')}}</span></el-dropdown-item>
                                </div>
                            </div>
                            <div v-if="activeListTab === 'engagements'">
                                <div v-if="myEngagementList.length !== 0">
                                    <el-dropdown-item v-for="item in myEngagementList" :key="item.id"><div  @click="setToPointEngagement(item.companyId, item.id)" >{{item.name}}</div></el-dropdown-item>
                                </div>
                                <div v-else>
                                    <el-dropdown-item disabled class="empty-head"><span>{{$t('header_no_e')}}</span></el-dropdown-item>
                                </div>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <!-- TASKS -->
            <div @mouseenter="getList('taskList')" class="notification__item">
                <el-dropdown>
                    <el-badge disabled class="item">
                        <!--<el-tooltip effect="dark" content="My Tasks" placement="bottom">-->
                        <el-button size="small">
                            <!-- <font-awesome-icon icon="project-diagram"/> -->
                            <img src="@/assets/img/toolbar/form.svg" width="18px" alt="">
                        </el-button>
                        <!--</el-tooltip>-->
                    </el-badge>
                    <el-dropdown-menu slot="dropdown">
<!--                        <el-tabs v-if="activeListTabTasks === 'projects'" v-model="activeTabStages" @tab-click="handleTabClick" class="project-task-tabs" tab-position="left" type="card">-->
<!--                            <el-tab-pane label="All" name="0"></el-tab-pane>-->
<!--                            <el-tab-pane v-for="stage in stages" :key="stage.id" :label="stage.name" :name="stage.id.toString()"></el-tab-pane>-->
<!--                        </el-tabs>-->
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_tasks')}}</span></el-dropdown-item>
                        <el-tabs v-model="activeListTabTasks" class="notification-tabs">
                            <el-tab-pane :label="$t('header_bu')" name="businessUnits">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="engagements">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="projects">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <!--<el-dropdown-item divided><span></span></el-dropdown-item>-->
                            <!--<el-dropdown-item disabled><div class="sub-title"><div>Project</div><div>Task</div></div></el-dropdown-item>-->
                            <el-dropdown-item v-if="myProjectTaskListModal.length === 0 && myBusinessUnitTaskList.length === 0 && myEngagementTaskList.length === 0" disabled class="empty-head"><span>{{$t('header_no_tasks')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-if="activeListTabTasks === 'projects'">
                                    <div v-if="myProjectTaskListModal.length !== 0">
                                        <el-dropdown-item v-for="item in myProjectTaskListModal" :key="item.id">
                                            <div class="line-select" @click="setToPointTask(item.project.companyId, item.project.id, item.id, 'projectTask')">
<!--                                              <div style="min-width:30px; display: flex; justify-content: flex-start; align-items: center;">-->
<!--                                                <img style="width: 23px; height: 23px;" :src="require(item.taskType === 1 ?  '@/assets/img/icons/icn_pr.svg' : item.params.typeId === 5 || item.params.typeId === 2 ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">-->
<!--                                              </div>-->
                                              <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                                <img
                                                    style="width: 23px; height: 23px;"
                                                    :src="require(
                                                        item.taskType === 'deadline' ? '@/assets/img/icons/icn_deadline.svg' :
                                                        item.taskType === 'recurring' ?  '@/assets/img/icons/icn_recurring.svg' :
                                                        '@/assets/img/icons/icn_project.svg')" alt="icon">
                                              </div>
                                              <div style="width:100%; margin-left:12px;">
                                                <div class="tasks-parent-name text-truncate">{{item.project ? item.project.name : ''}}</div>
                                                <div class="tasks-task-name text-truncate">{{item.name}}</div>
                                              </div>
                                              <div style="min-width:85px; text-align: right;">
                                              </div>
                                            </div>
                                        </el-dropdown-item>
                                    </div>
                                    <div v-else>
                                        <el-dropdown-item disabled class="empty-head"><span>No Tasks</span></el-dropdown-item>
                                    </div>
                                </div>
                                <div v-if="activeListTabTasks === 'businessUnits'">
                                    <div v-if="myBusinessUnitTaskList.length !== 0">
                                        <el-dropdown-item v-for="item in myBusinessUnitTaskList" :key="item.id">
                                            <div class="line-select" @click="setToPointTask(item.businessUnit.companyId, item.businessUnit.id, item.id, 'businessUnitTask')">
<!--                                              <div style="min-width:66px;"  v-html="item.taskType"></div>-->
                                              <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                                <img
                                                    style="width: 23px; height: 23px;"
                                                    :src="require(
                                                        item.taskType === 'deadline' ? '@/assets/img/icons/icn_deadline.svg' :
                                                        item.taskType === 'recurring' ?  '@/assets/img/icons/icn_recurring.svg' :
                                                        '@/assets/img/icons/icn_project.svg')" alt="icon">
                                              </div>
                                              <div style="width:100%; margin-left:12px;">
                                                <div class="tasks-parent-name text-truncate">{{item.businessUnit ? item.businessUnit.name : ''}}</div>
                                                <div class="tasks-task-name text-truncate">{{item.name}}</div>
                                              </div>
                                              <div style="min-width:85px; text-align: right;">
                                                <span v-if="item.taskType === 'deadline'">
                                                  {{moment(item.deadlineDate, 'X').format("ddd DD MMM 'YY")}}
                                                </span>
                                                <span v-if="item.taskType === 'recurring'">
                                                  {{moment(item.nextDueDate, 'X').format("ddd DD MMM 'YY")}}
                                                </span>
                                              </div>
                                            </div>
                                        </el-dropdown-item>
                                    </div>
                                    <div v-else>
                                        <el-dropdown-item disabled class="empty-head"><span>No Tasks</span></el-dropdown-item>
                                    </div>
                                </div>
                                <div v-if="activeListTabTasks === 'engagements'">
                                    <div v-if="myEngagementTaskList.length !== 0">
                                        <el-dropdown-item v-for="item in myEngagementTaskList" :key="item.id">
                                            <div class="line-select" @click="setToPointTask(item.engagement.companyId, item.engagement.id, item.id, 'engagementTask')">
<!--                                                <div style="min-width:66px;"  v-html="item.taskType"></div>-->
                                                <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                                  <img
                                                      style="width: 23px; height: 23px;"
                                                      :src="require(
                                                        item.taskType === 'deadline' ? '@/assets/img/icons/icn_deadline.svg' :
                                                        item.taskType === 'recurring' ?  '@/assets/img/icons/icn_recurring.svg' :
                                                        '@/assets/img/icons/icn_project.svg')" alt="icon">
                                                </div>
                                                <div style="width:100%; margin-left:12px;">
                                                  <div class="tasks-parent-name text-truncate">{{item.engagement ? item.engagement.name : ''}}</div>
                                                  <div class="tasks-task-name text-truncate">{{item.name}}</div>
                                                </div>
                                                <div style="min-width:85px; text-align: right;">
                                                  <span v-if="item.deadlineDate">
                                                    {{moment(item.deadlineDate, 'X').format("ddd DD MMM 'YY")}}
                                                  </span>
                                                  <span v-if="item.taskType === 'recurring'">
                                                  {{moment(item.nextDueDate, 'X').format("ddd DD MMM 'YY")}}
                                                </span>
                                                </div>
                                            </div>
                                        </el-dropdown-item>
                                    </div>
                                    <div v-else>
                                        <el-dropdown-item disabled class="empty-head"><span>No Tasks</span></el-dropdown-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <!-- TIMER -->
            <div v-if="user.notifications" @mouseenter="getList('timerList')" class="notification__item">
                <el-dropdown>
                    <el-badge :value="user.notifications.timerNotificationCount" :hidden="user.notifications.timerNotificationCount === 0" class="item">
                        <!--<el-tooltip effect="dark" content="My Tasks" placement="bottom">-->
                        <el-button size="small">
                            <!-- <font-awesome-icon icon="user-clock"/> -->
                            <img src="@/assets/img/toolbar/stopwatch.svg" width="18px" alt="">
                        </el-button>
                        <!--</el-tooltip>-->
                    </el-badge>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_timers')}}</span></el-dropdown-item>
                        <div>
                            <el-tabs v-model="activeListTabTimers" class="notification-tabs">
                                <el-tab-pane :label="$t('header_bu')" name="businessUnits">
                                </el-tab-pane>
                                <el-tab-pane :label="$t('header_e')" name="engagements">
                                </el-tab-pane>
                                <el-tab-pane :label="$t('header_project')" name="projects">
                                </el-tab-pane>
                            </el-tabs>
                            <div v-if="activeListTabTimers === 'projects'">
                                <el-dropdown-item v-if="myTimerList.length === 0" disabled class="empty-head"><span>{{$t('header_no_timers')}}</span></el-dropdown-item>
                                <div v-else>
                                    <div v-for="item in myTimerList" :key="item.id" class="box">
                                        <div class="timer-title">
                                            <div>{{item.project.name}}</div>
                                            <div class="title__time">
                                              <span style="margin-right: 0px;">
                                                <img v-show="item.status == 1" src="@/assets/img/live/live1.gif" width="12px;">
                                              </span>
                                              ({{totalTime(item.startDate, item.time, item.totalTime)}})
                                            </div>
                                            <!-- {{item.project.name}}
                                            ({{totalTime(item.startDate, item.time, item.totalTime)}}) -->
                                        </div>
                                        <div class="timer">
                                            <div class="timer__title" :title="item.projectTask.name">
                                            <span class="timer-link task-name" @click="setShared(item.companyId, item.projectId, item.projectTaskId, 0, item.company.name, 0, 'setShared', 'projects')">
                                                {{nameTimer(item.projectTask.name)}}
                                            </span>
                                                <!-- ({{totalTime(item.startDate, item.time, item.totalTime)}}) -->
                                            </div>
                                            <div class="timer__btn">
                                                <el-button class="timer__btn_item" v-if="item.status == 1" @click="pauseTimer(item.id, item.projectId, item.projectTask.id)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>
                                                <el-button class="timer__btn_item" v-else @click="restartTimer(item.id, item.projectId, item.projectTask.id)" type="primary" plain size="mini" icon="fas fa-play"></el-button>
                                                <el-button class="timer__btn_item" @click="stopTimer(item.id, item.startDate, item.time, item.totalTime, item.projectTask.id, item.projectId, item.projectTask.progress)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activeListTabTimers === 'businessUnits'">
                                <el-dropdown-item v-if="myTimerListDep.length === 0" disabled class="empty-head"><span>{{$t('header_no_timers')}}</span></el-dropdown-item>
                                <div v-else>
                                    <div v-for="item in myTimerListDep" :key="item.id" class="box">
                                        <div class="timer-title">
                                            <div>{{item.businessUnit.name}}</div>
                                            <div class="title__time">
                                              <span style="margin-right: 0px;">
                                                <img v-show="item.status == 1" src="@/assets/img/live/live1.gif" width="12px;">
                                              </span>
                                              ({{totalTime(item.startDate, item.time, item.totalTime)}})
                                            </div>
                                            <!-- {{item.businessUnit.name}} -->
                                        </div>
                                        <div class="timer">
                                            <div class="timer__title" :title="item.businessUnitTask.name">
                                            <span class="timer-link task-name" @click="setShared(item.companyId, item.businessUnitId, item.businessUnitTaskId, 0, item.company.name, 0, 'setShared', 'business-units')">
                                                {{nameTimer(item.businessUnitTask.name)}}
                                            </span>
                                                <!-- ({{totalTime(item.startDate, item.time, item.totalTime)}}) -->
                                            </div>
                                            <div class="timer__btn">
                                                <el-button class="timer__btn_item" v-if="item.status == 1" @click="pauseTimerDep(item.id, item.businessUnitId, item.businessUnitTask.id)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>
                                                <el-button class="timer__btn_item" v-else @click="restartTimerDep(item.id, item.businessUnitId, item.businessUnitTask.id)" type="primary" plain size="mini" icon="fas fa-play"></el-button>
                                                <el-button class="timer__btn_item" @click="stopTimerDep(item.id, item.startDate, item.time, item.totalTime, item.businessUnitTask.id, item.businessUnitId, item.businessUnitTask.progress)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="activeListTabTimers === 'engagements'">
                                <el-dropdown-item v-if="myTimerListEngagement.length === 0" disabled class="empty-head"><span>{{$t('header_no_timers')}}</span></el-dropdown-item>
                                <div v-else>
                                    <div v-for="item in myTimerListEngagement" :key="item.id" class="box">
                                        <div class="timer-title">
                                            <div>{{item.engagement.name}}</div>
                                            <div class="title__time">
                                              <span style="margin-right: 0px;">
                                                <img v-show="item.status == 1" src="@/assets/img/live/live1.gif" width="12px;">
                                              </span>
                                              ({{totalTime(item.startDate, item.time, item.totalTime)}})
                                            </div>
                                            <!-- {{item.engagement.name}} -->
                                        </div>
                                        <div class="timer">
                                            <div class="timer__title" :title="item.engagementTask.name">
                                            <span class="timer-link task-name" @click="setShared(item.companyId, item.engagementId, item.engagementTaskId, 0, item.company.name, 0, 'setShared', 'engagements')">
                                                {{nameTimer(item.engagementTask.name)}}
                                            </span>
                                                <!-- ({{totalTime(item.startDate, item.time, item.totalTime)}}) -->
                                            </div>
                                            <div class="timer__btn">
                                                <el-button class="timer__btn_item" v-if="item.status == 1" @click="pauseTimerEngagement(item.id, item.engagementId, item.engagementTask.id)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>
                                                <el-button class="timer__btn_item" v-else @click="restartTimerEngagement(item.id, item.engagementId, item.engagementTask.id)" type="primary" plain size="mini" icon="fas fa-play"></el-button>
                                                <el-button class="timer__btn_item" @click="stopTimerEngagement(item.id, item.startDate, item.time, item.totalTime, item.engagementTask.id, item.engagementId, item.engagementTask.progress)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dep -->
                        <!--<el-dropdown-item class="drop-down-head" disabled><span>My Business Unit Timers</span></el-dropdown-item>-->
                        <!--<div>-->
                        <!--<el-dropdown-item divided><span></span></el-dropdown-item>-->
                        <!--<el-dropdown-item v-if="myTimerListDep.length === 0" disabled class="empty-head"><span>No Timers</span></el-dropdown-item>-->
                        <!--<div v-else>-->
                        <!--&lt;!&ndash; <el-dropdown-item v-for="item in myTimerListDep" :key="item.id"> &ndash;&gt;-->
                        <!--<div v-for="item in myTimerListDep" :key="item.id" class="box">-->
                        <!--<div class="title">{{item.businessUnit.name}}</div>-->
                        <!--<div class="timer">-->
                        <!--<div class="timer__title" :title="item.businessUnitTask.name">-->
                        <!--<router-link :to="{ path: 'business-units', query: { companyId: item.companyId, businessUnitId: item.businessUnitId, taskId: item.businessUnitTask.id }}">-->
                        <!--{{nameTimer(item.businessUnitTask.name)}}-->
                        <!--</router-link>-->
                        <!--({{totalTime(item.startDate, item.time, item.totalTime)}})-->
                        <!--</div>-->
                        <!--<div class="timer__btn">-->
                        <!--<el-button class="timer__btn_item" v-if="item.status == 1" @click="pauseTimerDep(item.id, item.businessUnitId, item.businessUnitTask.id)" type="warning" plain size="mini" icon="fas fa-pause"></el-button>-->
                        <!--<el-button class="timer__btn_item" v-else @click="restartTimerDep(item.id, item.businessUnitId, item.businessUnitTask.id)" type="primary" plain size="mini" icon="fas fa-play"></el-button>-->
                        <!--<el-button class="timer__btn_item" @click="stopTimerDep(item.id, item.startDate, item.time, item.totalTime, item.businessUnitTask.id, item.businessUnitId, item.businessUnitTask.progress)" type="danger" plain size="mini" icon="fas fa-stop"></el-button>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--&lt;!&ndash; <div  class="tasks-dropdown" @click="setToPointTask(item.companyId, item.projectId || item.businessUnitId , item.projectTaskId || item.businessUnitTaskId, item.type)" > <span class="tasks-dropdown_name">{{item.projectTaskName || item.businessUnitTaskName}}</span> <span >{{item.type}}</span> </div> &ndash;&gt;-->
                        <!--&lt;!&ndash; </el-dropdown-item> &ndash;&gt;-->
                        <!--</div>-->
                        <!--</div>-->

                    </el-dropdown-menu>
                    <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item v-for="item in notifications" :key="item.id"><span  @click="setShared(item.companyId, item.id, null, null, null, null, '')" >{{item.type}}</span></el-dropdown-item>-->
                    <!--</el-dropdown-menu>-->
                </el-dropdown>
            </div>
        </div>

        <div class="notification">
            <div v-if="user.notifications" @mouseenter="loadNotifications(1, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.generalNotificationCount" :hidden="user.notifications.generalNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/circle-menu.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div id="general"
                             class="dropdown-wrap">
                            <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_general')}}</span></el-dropdown-item>
                            <div>
                                <el-dropdown-item divided><span></span></el-dropdown-item>
                                <el-dropdown-item v-if="generalNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_notifications')}}</span></el-dropdown-item>
                                <div v-else>
                                    <div v-for="parent in generalNotifications" :key="parent.id">
                                        <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                            <el-tag effect="plain" size="small">
                                                {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                            </el-tag>
                                        </div>
                                        <el-dropdown-item class="line-select-general" v-for="(item, index) in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                            <div style="width:100%;" @click="general(
                                        item.action,
                                        item.id,
                                        item.params._companyId,
                                        item.params.companyName,
                                        item.params._email,
                                        item.params._hash,
                                        item.params._projectId || item.params._engagementId || item.params._businessUnitId,
                                        item.params._projectTaskId || item.params._engagementTaskId || item.params._businessUnitTaskId ,
                                        item.params._projectTaskExpenseId || item.params._engagementExpenseId || item.params._businessUnitExpenseId || item.params._projectTaskCashAdvanceId || item.params._projectTaskCashAdvanceRequestId || item.params._purchaseRequestId || item.params._vendorInvoiceRequestId,
                                        item.params._tempSharedProjectTaskId,
                                        item.fromUserName,
                                        item.params.projectTaskName,
                                        item.params)">
                                                <el-tooltip popper-class="general-tool-tip" placement="left">
                                                    <div slot="content" class="general-tool-tip_content">
                                                        <span v-if="item.createDate">Time: {{moment(item.createDate.toString(), 'X').format("ddd DD MMM 'YY")}}<br/></span>
                                                        <span v-if="item.params.companyName">Company: {{item.params.companyName}}<br/></span>
                                                        <span v-if="item.params.projectName">Project: {{item.params.projectName}}<br/></span>
                                                        <span v-if="item.params.businessUnitName">Business Unit: {{item.params.businessUnitName}}<br/></span>
                                                        <span v-if="item.params.engagementName">Engagement: {{item.params.engagementName}}<br/></span>
                                                        <span v-if="item.params.projectTaskName">Task: {{item.params.projectTaskName}}<br/></span>
                                                        <span v-if="item.params.businessUnitTaskName">Task: {{item.params.businessUnitTaskName}}<br/></span>
                                                        <span v-if="item.params.engagementTaskName">Task: {{item.params.engagementTaskName}}<br/></span>
                                                        <span v-if="item.params.inviteId">Invite. No:{{item.params.inviteId}}<br/></span>
                                                        <span v-if="item.action === 'inviteCompanyUser'">From User: {{item.fromUserName}}<br/></span>
                                                        <span v-else-if="item.action === 'Invitation approved'">Accepted by: {{item.fromUserName}}<br/></span>
                                                        <span v-else-if="item.action === 'Invitation rejected'">Rejected by: {{item.fromUserName}}<br/></span>
                                                        <span v-else>{{$t('notification_addedBy')}}: {{item.fromUserName}}<br/></span>
                                                        <span v-if="item.params.userEmail">User Email:{{item.params.userEmail}}<br/></span>
                                                    </div>
                                                    <div class="line-select" style="gap: 6px;">
                                                        <div style="min-width:20px;"  v-html="index + 1"></div>
                                                        <div class="text-truncate-general-date" >{{moment(item.createDate.toString(), 'X').format('h:mm a')}}</div>
                                                        <!--<div class="text-truncate-general-action">{{$t('notification_action_'+item.action)}}</div>-->
                                                      <div style="max-width: 210px" class="text-truncate" v-html="item.params.companyName"></div>

                                                    </div>
                                                </el-tooltip>
                                            </div>
                                            <el-button @click="removeNotificationOpenModal(item.id)" class="close-btn" type="primary" icon="el-icon-close" circle plain size="mini" ></el-button>
                                        </el-dropdown-item>
                                    </div>
                                </div>
                            </div>
                            <infinite-loading
                                    @infinite="infiniteHandler">
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </infinite-loading>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="user.notifications" @mouseenter="loadNotifications(9, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.financeNotificationCount" :hidden="user.notifications.financeNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/dollar-sign.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <div id="finance">
                            <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_accountTHINK')}}</span></el-dropdown-item>
                            <div>
                                <el-row class="drop-down-head-general" disabled :span="24">
                                    <el-col class="drop-down-head-general_header" :span="12">{{$t('header_time')}}</el-col>
                                    <el-col class="drop-down-head-general_header" :span="12">{{$t('header_action')}}</el-col>
                                </el-row>
                            </div>


                            <div>
                                <el-dropdown-item divided><span></span></el-dropdown-item>
                                <el-dropdown-item v-if="financeNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_accountTHINK')}}</span></el-dropdown-item>
                                <div v-else>
                                    <el-dropdown-item v-for="item in financeNotifications" :key="item.id">
                                        <div @click="general(
                                        item.action,
                                        item.id,
                                        item.params._companyId,
                                        item.params.companyName,
                                        item.params._email,
                                        item.params._hash,
                                        item.params._projectId || item.params._engagementId || item.params._businessUnitId,
                                        item.params._projectTaskId || item.params._engagementTaskId || item.params._businessUnitTaskId ,
                                        item.params._projectTaskExpenseId || item.params._engagementExpenseId || item.params._businessUnitExpenseId || item.params._projectTaskCashAdvanceId || item.params._projectTaskCashAdvanceRequestId || item.params._purchaseRequestId || item.params._vendorInvoiceRequestId,
                                        item.params._tempSharedProjectTaskId,
                                        item.fromUserName,
                                        item.params.projectTaskName)">
                                            <el-tooltip popper-class="general-tool-tip" placement="left">
                                                <div slot="content" class="general-tool-tip_content">
                                                    <span v-if="item.createDate">Time: {{moment(item.createDate.toString(), 'X').format('DD MMMM YYYY, h:mm a')}}<br/></span>
                                                    <span v-if="item.params.companyName">Company: {{item.params.companyName}}<br/></span>
                                                    <span v-if="item.params.projectName">Project: {{item.params.projectName}}<br/></span>
                                                    <span v-if="item.params.businessUnitName">Business Unit: {{item.params.businessUnitName}}<br/></span>
                                                    <span v-if="item.params.engagementName">Engagement: {{item.params.engagementName}}<br/></span>
                                                    <span v-if="item.params.projectTaskName">Task: {{item.params.projectTaskName}}<br/></span>
                                                    <span v-if="item.params.businessUnitTaskName">Task: {{item.params.businessUnitTaskName}}<br/></span>
                                                    <span v-if="item.params.engagementTaskName">Task: {{item.params.engagementTaskName}}<br/></span>
                                                    <span v-if="item.fromUserName">{{$t('notification_addedBy')}}: {{item.fromUserName}}<br/></span>
                                                    <span v-if="item.params.message">Message: {{item.params.message}}<br/></span>
                                                </div>
                                                <div class="line-select">
                                                    <span>{{moment(item.createDate.toString(), 'X').format('DD MMMM YYYY, h:mm a')}}</span>
                                                    <div class="text-truncate" v-html="item.params.companyName"></div>
                                                    <!--<span>{{item.action}}</span>-->
                                                </div>
                                            </el-tooltip>
                                        </div>
                                    </el-dropdown-item>
                                </div>
                            </div>
                            <infinite-loading
                                    @infinite="infiniteHandler">
                                <div slot="no-more"></div>
                                <div slot="no-results"></div>
                            </infinite-loading>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="user.notifications" @mouseenter="loadNotifications(2, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.taskProgressNotificationCount" :hidden="user.notifications.taskProgressNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/bar-chart.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_progress_notes')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="taskProgressNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_progress_notes')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="(parent, index) in taskProgressNotifications" :key="parent.id">
                                    <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                        <el-tag effect="plain" size="small">
                                            {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                        </el-tag>
                                        <el-button v-if="index === 0" class="mark-as-read" size="mini" @click="asRead(taskProgressNotifications[0].arrayDate[0].type)" type="primary" plain>{{$t('header_markAsRead')}}</el-button>
                                    </div>

                                    <el-dropdown-item v-for="item in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                      <el-tooltip popper-class="general-tool-tip" placement="left">
                                        <div slot="content" class="general-tool-tip_content">
                                          <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                          <span v-if="item.params.projectName">{{$t('notification_project')}}: {{item.params.projectName}}<br/></span>
                                          <span v-if="item.params.businessUnitName">{{$t('notification_businessUnit')}}: {{item.params.businessUnitName}}<br/></span>
                                          <span v-if="item.params.engagementName">{{$t('notification_engagement')}}: {{item.params.engagementName}}<br/></span>
                                          <span v-if="item.params.projectTaskName">{{$t('notification_task')}}: {{item.params.projectTaskName}}<br/></span>
                                          <span v-if="item.params.businessUnitTaskName">{{$t('notification_task')}}: {{item.params.businessUnitTaskName}}<br/></span>
                                          <span v-if="item.params.engagementTaskName">{{$t('notification_task')}}: {{item.params.engagementTaskName}}<br/></span>
                                        </div>
                                        <div class="line-select" @click="checkIfCompanySelected(
                                                                                            item.params._companyId,
                                                                                            item.params._projectId || item.params._businessUnitId || item.params._engagementId,
                                                                                            item.params._projectTaskId || item.params._businessUnitTaskId || item.params._engagementTaskId,
                                                                                            item.params._projectTaskProgressId || item.params._businessUnitTaskProgressId || item.params._engagementTaskProgressId,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                            'setShared',
                                                                                            item.params._projectId ? 'projects' : item.params._businessUnitId ? 'business-units' : 'engagements',
                                                                                            item.type)">
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                              <img style="width: 23px; height: 23px;" :src="require(item.params.projectTaskName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                            <div style="min-width:45px; display:flex; justify-content: center; align-items: center; margin-right: 10px;">
                                              <img style="width: 100%;" :src="setProgressNotificationImg(item.action)" alt="status-icon">
                                            </div>
                                          <div class="text-truncate" v-html="item.params.companyName"></div>
                                          <!--<div class="text-truncate" v-html="item.params.projectName || item.params.businessUnitName|| item.params.engagementName"></div>-->
                                          <!--<div class="text-truncate" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></div>-->
                                        </div>
                                      </el-tooltip>
                                    </el-dropdown-item>
                                </div>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="user.notifications" @mouseenter="loadNotifications(4, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.commentNotificationCount" :hidden="user.notifications.commentNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/pencil-edit.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_comments')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="commentNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_comments')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="(parent, index) in commentNotifications" :key="parent.id">
                                    <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                        <el-tag effect="plain" size="small">
                                            {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                        </el-tag>
                                        <el-button v-if="index === 0" class="mark-as-read" size="mini" @click="asRead(commentNotifications[0].arrayDate[0].type)" type="primary" plain>{{$t('header_markAsRead')}}</el-button>
                                    </div>
                                    <el-dropdown-item v-for="item in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                      <el-tooltip popper-class="general-tool-tip" placement="left">
                                        <div slot="content" class="general-tool-tip_content">
                                          <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                          <span v-if="item.params.projectName">{{$t('notification_project')}}: {{item.params.projectName}}<br/></span>
                                          <span v-if="item.params.businessUnitName">{{$t('notification_businessUnit')}}: {{item.params.businessUnitName}}<br/></span>
                                          <span v-if="item.params.engagementName">{{$t('notification_engagement')}}: {{item.params.engagementName}}<br/></span>
                                          <span v-if="item.params.projectTaskName">{{$t('notification_task')}}: {{item.params.projectTaskName}}<br/></span>
                                          <span v-if="item.params.businessUnitTaskName">{{$t('notification_task')}}: {{item.params.businessUnitTaskName}}<br/></span>
                                          <span v-if="item.params.engagementTaskName">{{$t('notification_task')}}: {{item.params.engagementTaskName}}<br/></span>
                                        </div>
                                        <div class="line-select" @click="checkIfCompanySelected(
                                                                                            item.params._companyId,
                                                                                            item.params._projectId || item.params._businessUnitId || item.params._engagementId,
                                                                                            item.params._projectTaskId || item.params._businessUnitTaskId || item.params._engagementTaskId,
                                                                                            item.params._projectTaskCommentId || item.params._businessUnitTaskCommentId || item.params._engagementTaskCommentId || item.params._projectCommentId || item.params._businessUnitCommentId  || item.params._engagementCommentId,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                            item.action,
                                                                                            item.params._projectId ? 'projects' : item.params._businessUnitId ? 'business-units' : 'engagements',
                                                                                            item.type)">
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                              <img style="width: 23px; height: 23px;" :src="require(item.params.projectTaskName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                            <div class="text-truncate" v-html="item.params.companyName"></div>
                                          <!--<span class="text-truncate" v-html="item.params.projectName || item.params.businessUnitName || item.params.engagementName"></span>-->
                                          <!--<span class="text-truncate" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></span>-->
                                        </div>
                                      </el-tooltip>
                                    </el-dropdown-item>
                                </div>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="user.notifications" @mouseenter="loadNotifications(3, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.messageNotificationCount" :hidden="user.notifications.messageNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/mail.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_messages')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="messageNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_messages')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="(parent, index) in messageNotifications" :key="parent.id">
                                    <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                        <el-tag effect="plain" size="small">
                                            {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                        </el-tag>
                                        <el-button v-if="index === 0" class="mark-as-read" size="mini" @click="asRead(messageNotifications[0].arrayDate[0].type)" type="primary" plain>{{$t('header_markAsRead')}}</el-button>
                                    </div>

                                    <el-dropdown-item v-for="item in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                      <el-tooltip popper-class="general-tool-tip" placement="left">
                                        <div slot="content" class="general-tool-tip_content">
                                          <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                          <span v-if="item.params.projectName">{{$t('notification_project')}}: {{item.params.projectName}}<br/></span>
                                          <span v-if="item.params.businessUnitName">{{$t('notification_businessUnit')}}: {{item.params.businessUnitName}}<br/></span>
                                          <span v-if="item.params.engagementName">{{$t('notification_engagement')}}: {{item.params.engagementName}}<br/></span>
                                          <span v-if="item.params.projectTaskName">{{$t('notification_task')}}: {{item.params.projectTaskName}}<br/></span>
                                          <span v-if="item.params.businessUnitTaskName">{{$t('notification_task')}}: {{item.params.businessUnitTaskName}}<br/></span>
                                          <span v-if="item.params.engagementTaskName">{{$t('notification_task')}}: {{item.params.engagementTaskName}}<br/></span>
                                        </div>
                                        <div class="line-select" @click="checkIfCompanySelected(
                                                                                            item.params._companyId,
                                                                                            item.params._projectId || item.params._businessUnitId || item.params._engagementId,
                                                                                            item.params._projectTaskId || item.params._businessUnitTaskId || item.params._engagementTaskId,
                                                                                            item.params.projectTaskMessageId || item.params._businessUnitTaskMessageId || item.params._engagementTaskMessageId,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                            item.action,
                                                                                            item.params._projectId ? 'projects' : item.params._businessUnitId ? 'business-units' : 'engagements',
                                                                                            item.type)">
                                          <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                            <img style="width: 23px; height: 23px;" :src="require(item.params.projectTaskName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                          </div>
                                          <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                          <div class="text-truncate" v-html="item.params.companyName"></div>
                                          <!--<div class="text-truncate" v-html="item.params.projectName || item.params.businessUnitName || item.params.engagementName"></div>-->
                                          <!--<div class="text-truncate" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></div>-->
                                        </div>
                                      </el-tooltip>
                                    </el-dropdown-item>
                                </div>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div v-if="user.notifications" @mouseenter="loadMeetingNotifications(null)" class="notification__item with-badge">
                <el-badge :value="user.notifications.meetingNotificationCount" :hidden="user.notifications.meetingNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/meeting.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_myMeetings')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickMeetingNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="meetingsNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_messages')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="(parent, index) in meetingsNotifications" :key="parent.id">
                                    <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                        <el-tag effect="plain" size="small">
                                            {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                        </el-tag>
                                      <div style="display:flex; align-items:center;">
                                        <el-button v-if="index === 0" style="padding: 4px;" class="mark-as-read" size="mini" @click="openMeetingCalendar()" type="primary" plain>
                                          <img src="@/assets/img/info/calendar_icn.svg" width="15px;">
                                        </el-button>
                                        <el-button v-if="index === 0" class="mark-as-read" size="mini" @click="asRead(meetingsNotifications[0].arrayDate[0].type)" type="primary" plain>{{$t('header_markAsRead')}}</el-button>
                                      </div>
                                    </div>
                                    <el-dropdown-item v-for="item in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                      <el-tooltip popper-class="general-tool-tip" placement="left">
                                        <div slot="content" class="general-tool-tip_content">
                                          <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                          <span v-if="item.params.typeId === 4 || item.params.typeId === 1">{{$t('notification_project')}}: {{item.params.parentName}}<br/></span>
                                          <span v-if="item.params.typeId === 5 || item.params.typeId === 2">{{$t('notification_businessUnit')}}: {{item.params.parentName}}<br/></span>
                                          <span v-if="item.params.typeId === 6 || item.params.typeId === 3">{{$t('notification_engagement')}}: {{item.params.parentName}}<br/></span>
                                          <span v-if="item.params.taskName">{{$t('notification_task')}}: {{item.params.taskName}}<br/></span>

                                          <!--if meeting selected-->
                                          <div v-if="item.params._meetingId" style="margin-top:10px;">
                                            <div>{{$t('notification_meetingDetails')}}</div>
                                            <div>{{$t('notification_title')}}: {{item.params.meetingName}}</div>
                                            <div>{{$t('notification_roomId')}}: {{item.params.roomId}}</div>
                                            <div>{{$t('notification_starting')}}: {{moment(item.params._timeStartMeeting.toString(), 'X').format('DD MMMM YYYY, h:mm a')}}</div>
                                            <div>{{$t('notification_host')}}: {{item.params.hostName}}</div>
                                            <div>{{$t('notification_team')}}: <span v-for="(userName, index) in item.params.teamNameArr" :key="index"> {{userName}}</span></div>
                                            <div>{{$t('notification_status')}}: <span>{{item.params.status === 1 ? $t('notification_pending') : item.params.status === 2 ? $t('notification_started') : $t('notification_closed')}}</span></div>
                                          </div>
                                        </div>
                                            <div class="line-select" @click="openModalConfirmMeeting(
                                                                                            item.params._companyId,
                                                                                            item.params._parentId,
                                                                                            item.params.taskId,
                                                                                            item.params._meetingId,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                            item.action,
                                                                                            item.params.parentName,
                                                                                            item.params.taskName,
                                                                                            item.params.meetingName,
                                                                                            item.params._timeStartMeeting,
                                                                                            item.params.roomId,
                                                                                            item.params.typeId,
                                                                                            item.type)">
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                               <img style="width: 23px; height: 23px;" :src="require(item.params.typeId === 4 || item.params.typeId === 1 ?  '@/assets/img/icons/icn_pr.svg' : item.params.typeId === 5 || item.params.typeId === 2 ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
<!--                                            <div style="min-width:30px;"  v-html="item.params.typeId === 4 || item.params.typeId === 1 ? 'PR' : item.params.typeId === 5 || item.params.typeId === 2 ? 'BU' : 'EN'"></div>-->
                                            <div style="min-width:64px;" class="text-truncate">{{moment(item.params._timeStartMeeting, 'X').format("LT")}}</div>
                                            <div class="text-truncate" v-html="item.params.companyName"></div>
<!--                                            <div class="text-truncate" v-html="item.params.parentName"></div>-->
<!--                                            <div class="text-truncate" v-html="item.params.taskName"></div>-->
<!--                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>-->
                                          </div>
                                      </el-tooltip>
                                    </el-dropdown-item>
                                </div>
<!--                                <infinite-loading-->
<!--                                        @infinite="infiniteHandler">-->
<!--                                    <div slot="no-more"></div>-->
<!--                                    <div slot="no-results"></div>-->
<!--                                </infinite-loading>-->
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div v-if="user.notifications" @mouseenter="loadNotifications(6, 1, null)" class="notification__item with-badge">
                <el-badge :value="user.notifications.reminderNotificationCount" :hidden="user.notifications.reminderNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/bell.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_reminders')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="reminderNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_reminders')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="(parent, index) in reminderNotifications" :key="parent.id" >
                                    <div style="display:flex; justify-content:space-between; padding:0 10px;">
                                        <el-tag effect="plain" size="small">
                                            {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                        </el-tag>
                                        <el-button v-if="index === 0" class="mark-as-read" size="mini" @click="asRead(reminderNotifications[0].arrayDate[0].type)" type="primary" plain>{{$t('header_markAsRead')}}</el-button>
                                    </div>
                                    <el-dropdown-item v-for="item in parent.arrayDate" :key="item.id" :class="{'unchecked-item': !item.show}">
                                        <el-tooltip popper-class="general-tool-tip" placement="left">
                                            <div slot="content" class="general-tool-tip_content">
                                                <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                                <span v-if="item.params.projectName">{{$t('notification_project')}}: {{item.params.projectName}}<br/></span>
                                                <span v-if="item.params.businessUnitName">{{$t('notification_businessUnit')}}: {{item.params.businessUnitName}}<br/></span>
                                                <span v-if="item.params.engagementName">{{$t('notification_engagement')}}: {{item.params.engagementName}}<br/></span>

                                                <!-- meeting tooltip parent name -->
                                                <span v-if="item.action === 'customReminderProjectMeeting' || item.action === 'customReminderEngagementMeeting' || item.action === 'customReminderBusinessUnitMeeting'">
                                                  {{item.params.typeId === 1 || item.params.typeId === 4 ? $t('notification_project') :
                                                  item.params.typeId === 2 || item.params.typeId === 5 ? $t('notification_businessUnit') :
                                                      $t('notification_engagement')}}: {{item.params.parentName}}<br/></span>
                                                <!-- meeting tooltip parent name -->

                                                <span v-if="item.params.projectTaskName">{{$t('notification_task')}}: {{item.params.projectTaskName}}<br/></span>
                                                <span v-if="item.params.businessUnitTaskName">{{$t('notification_task')}}: {{item.params.businessUnitTaskName}}<br/></span>
                                                <span v-if="item.params.engagementTaskName">{{$t('notification_task')}}: {{item.params.engagementTaskName}}<br/></span>
                                                <span v-if="item.params.taskName">{{$t('notification_task')}}: {{item.params.taskName}}<br/></span>

                                                <!--if meeting selected-->
                                                <div v-if="item.params._meetingId" style="margin-top:10px;">
                                                    <div>{{$t('notification_meetingDetails')}}</div>
                                                    <div>{{$t('notification_title')}}: {{item.params.meetingName}}</div>
                                                    <div>{{$t('notification_roomId')}}: {{item.params.roomId}}</div>
                                                    <div>{{$t('notification_starting')}}: {{moment(item.params._timeStartMeeting.toString(), 'X').format('DD MMMM YYYY, h:mm a')}}</div>
                                                    <div>{{$t('notification_host')}}: {{item.params.hostName}}</div>
                                                    <div>{{$t('notification_team')}}: <span v-for="(userName, index) in item.params.teamNameArr" :key="index"> {{userName}}</span></div>
                                                    <div>{{$t('notification_status')}}: <span>{{item.params.status === 1 ? $t('notification_pending') : item.params.status === 2 ? $t('notification_started') : $t('notification_closed')}}</span></div>
                                                </div>
                                            </div>
                                        <!--meetings reminders start-->
                                        <div v-if="item.action === 'customReminderProjectMeeting' || item.action === 'customReminderEngagementMeeting' || item.action === 'customReminderBusinessUnitMeeting'" class="line-select"
                                             @click="checkIfCompanySelected(
                                                item.params._companyId,
                                                item.params._parentId,
                                                item.params._taskId,
                                                item.params._meetingId,
                                                item.params.companyName,
                                                item.id,
                                                item.params.typeId === 1 ? 'createProjectMeetings' : item.params.typeId === 4 ? 'createProjectTaskMeetings' : item.params.typeId === 2 ? 'createBusinessUnitMeeting' :
                                                item.params.typeId === 5 ? 'createBusinessUnitTaskMeeting' : item.params.typeId === 3 ? 'createEngagementMeeting' : 'createEngagementTaskMeeting' ,
                                                item.params.typeId === 1 || item.params.typeId === 4 ? 'projects' : item.params.typeId === 2 || item.params.typeId === 5 ? 'business-units' : 'engagements',
                                                item.type)">
<!--                                          <div style="min-width:30px;"  v-html="item.params.typeId === 1 || item.params.typeId === 4 ? 'PR' : item.params.typeId === 2 || item.params.typeId === 5 ? 'BU' : 'EN'"></div>-->
                                          <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                            <img style="width: 23px; height: 23px;" :src="require(item.params.typeId === 4 || item.params.typeId === 1 ?  '@/assets/img/icons/icn_pr.svg' : item.params.typeId === 5 || item.params.typeId === 2 ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                          </div>
                                          <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                          <div class="text-truncate" v-html="item.params.companyName"></div>
<!--                                          <div class="text-truncate" v-html="item.params.parentName"></div>-->
<!--                                          <div class="text-truncate" v-html="item.params.taskName"></div>-->
                                          <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-end; margin-left: auto;">
                                            <img style="width: 23px; height: 23px;" :src="require('@/assets/img/icons/icn_meeting.svg')" alt="icon">
                                          </div>
                                        </div>
                                        <!--meetings reminders ends-->

                                        <!--reccuring deadlines notifications start-->
                                          <div v-else-if="item.action === 'engagementDeadLineOverdue' || item.action === 'businessUnitDeadLineOverdue' || item.action === 'engagementReccuringOverdue' || item.action === 'businessUnitReccuringOverdue'" class="line-select"
                                               @click="general(
                                                  item.action,
                                                  item.id,
                                                  item.params._companyId,
                                                  item.params.companyName,
                                                  item.params._email,
                                                  item.params._hash,
                                                  item.params._projectId || item.params._engagementId || item.params._businessUnitId,
                                                  item.params._projectTaskId || item.params._engagementTaskId || item.params._businessUnitTaskId ,
                                                  item.params._projectTaskExpenseId || item.params._engagementExpenseId || item.params._businessUnitExpenseId || item.params._projectTaskCashAdvanceId || item.params._projectTaskCashAdvanceRequestId || item.params._purchaseRequestId || item.params._vendorInvoiceRequestId,
                                                  item.params._tempSharedProjectTaskId,
                                                  item.fromUserName,
                                                  item.params.projectTaskName)">
                                            <!--                                            <div style="min-width:30px;"  v-html="item.params.projectName ? 'PR' : item.params.businessUnitName ? 'BU' : 'EN'"></div>-->
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                              <img style="width: 23px; height: 23px;" :src="require(item.params.projectName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                            <div class="text-truncate" v-html="item.params.companyName"></div>
<!--                                            <div class="text-truncate" v-html="item.params.projectName || item.params.businessUnitName || item.params.engagementName"></div>-->
<!--                                            <div class="text-truncate" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></div>-->
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-end; margin-left: auto;">
                                              <img
                                                  style="width: 23px; height: 23px;"
                                                  :src="require(
                                                      item.action === 'engagementDeadLineOverdue' ||
                                                      item.action === 'businessUnitDeadLineOverdue' ? '@/assets/img/icons/icn_deadline.svg' :
                                                      '@/assets/img/icons/icn_recurring.svg')" alt="icon">
                                            </div>
                                          </div>
                                        <!--reccuring deadlines notifications ends-->

                                        <!--progress reminders starts-->
                                        <div v-else class="line-select" @click="checkIfCompanySelected(
                                                                                            item.params._companyId,
                                                                                            item.params._projectId || item.params._businessUnitId || item.params._engagementId,
                                                                                            item.params._projectTaskId || item.params._businessUnitTaskId || item.params._engagementTaskId,
                                                                                            item.params._projectTaskProgressId || item.params._businessUnitTaskProgressId || item.params._engagementTaskProgressId,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                       'setShared',
                                                                                            item.params._projectId ? 'projects' : item.params._businessUnitId ? 'business-units' : 'engagements',
                                                                                            2)">
<!--                                            <div style="min-width:30px;"  v-html="item.params.projectName ? 'PR' : item.params.businessUnitName ? 'BU' : 'EN'"></div>-->
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                              <img style="width: 23px; height: 23px;" :src="require(item.params.projectName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                            <div class="text-truncate" v-html="item.params.companyName"></div>
<!--                                            <div class="text-truncate" v-html="item.params.projectName || item.params.businessUnitName || item.params.engagementName"></div>-->
<!--                                            <div class="text-truncate" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></div>-->
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-end; margin-left: auto;">
                                              <img
                                                  style="width: 23px; height: 23px;"
                                                  :src="require('@/assets/img/icons/icn_project.svg')" alt="icon">
                                            </div>
                                        </div>
                                        <!--progress reminders ends-->

                                        </el-tooltip>
                                    </el-dropdown-item>
                                </div>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div v-if="user.notifications" @mouseenter="loadNotifications(8, 1, 'null')" class="notification__item with-badge">
                <el-badge :value="user.notifications.documentNotificationCount" :hidden="user.notifications.documentNotificationCount === 0" class="item">
                </el-badge>
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/folder.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_documents')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleClickNotiTab" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="null">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="BusinessUnit">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="Engagement">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="Project">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="documentNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_documents')}}</span></el-dropdown-item>
                            <div v-else>
                                <div v-for="parent in documentNotifications" :key="parent.id" >
                                    <el-tag style="margin-left:10px;" effect="plain" size="small">
                                        {{moment(parent.dateCheck, 'DD MMMM YY').format("ddd DD MMM 'YY" )}}
                                    </el-tag>
                                    <el-dropdown-item v-for="item in parent.arrayDate" :class="{'unchecked-item': !item.show}" :key="item.id">
                                      <el-tooltip popper-class="general-tool-tip" placement="left">
                                        <div slot="content" class="general-tool-tip_content">
                                          <span>{{$t('notification_company')}}: {{item.params.companyName}}<br/></span>
                                          <span v-if="item.params.projectName">{{$t('notification_project')}}: {{item.params.projectName}}<br/></span>
                                          <span v-if="item.params.businessUnitName">{{$t('notification_businessUnit')}}: {{item.params.businessUnitName}}<br/></span>
                                          <span v-if="item.params.engagementName">{{$t('notification_engagement')}}: {{item.params.engagementName}}<br/></span>
                                          <span v-if="item.params.projectTaskName">{{$t('notification_task')}}: {{item.params.projectTaskName}}<br/></span>
                                          <span v-if="item.params.businessUnitTaskName">{{$t('notification_task')}}: {{item.params.businessUnitTaskName}}<br/></span>
                                          <span v-if="item.params.engagementTaskName">{{$t('notification_task')}}: {{item.params.engagementTaskName}}<br/></span>
                                          <span>{{$t('notification_actionBy')}}: {{ item.fromUserName }}<br/></span>
                                          <span>{{$t('notification_documentType')}}: {{ item.params.type }}<br/></span>
                                          <span>{{$t('notification_documentTitle')}}: {{ item.params.documentTitle }}<br/></span>
                                          <span>{{$t('notification_documentNo')}}: {{ item.params.documentNo }}<br/></span>
                                        </div>
                                        <div class="line-select" @click="clickDocument(
                                                                                            item.params._companyId,
                                                                                            item.params._projectId || item.params._businessUnitId || item.params._engagementId,
                                                                                            item.params._projectTaskId || item.params._businessUnitTaskId || item.params._engagementTaskId,
                                                                                            item.params.type,
                                                                                            item.params.companyName,
                                                                                            item.id,
                                                                                            item.action,
                                                                                            item.params._projectId ? 'projects' : item.params._businessUnitId ? 'business-units' : 'engagements',
                                                                                            item.type,
                                                                                            item.params)">
                                            <div style="min-width:30px; display:flex; align-items: center; justify-content: flex-start;">
                                              <img style="width: 23px; height: 23px;" :src="require(item.params.projectName ?  '@/assets/img/icons/icn_pr.svg' : item.params.businessUnitName ? '@/assets/img/icons/icn_bu.svg' : '@/assets/img/icons/icn_en.svg')" alt="icon">
                                            </div>
                                            <div style="min-width:64px;"  v-html="moment(item.createDate, 'X').format('LT')"></div>
                                            <div class="text-truncate-doc" v-html="item.params.companyName"></div>
<!--                                            <div class="text-truncate-doc" v-html="item.params.projectName || item.params.businessUnitName || item.params.engagementName"></div>-->
<!--                                            <div class="text-truncate-doc" v-html="item.params.projectTaskName || item.params.businessUnitTaskName || item.params.engagementTaskName"></div>-->
                                            <div class="text-truncate-doc" v-html="item.params.type"></div>
<!--                                            <div class="text-truncate-doc" style="text-align: right;">{{$t(`notification_${item.action}`)}}</div>-->
                                            <div class="text-truncate-doc" style="display: flex; justify-content: flex-end; align-items: center;">
                                              <img v-if="item.action === 'acceptEngagementTaskDocument' || item.action === 'acceptBusinessUnitTaskDocument' || item.action === 'acceptProjectTaskDocument'" src="@/assets/img/icons/btn_accept.svg" width="45px" alt="">
                                              <img v-else-if="item.action === 'rejectEngagementTaskDocument' || item.action === 'rejectBusinessUnitTaskDocument' || item.action === 'rejectProjectTaskDocument'" src="@/assets/img/icons/btn_reject.svg" width="45px" alt="">
                                              <div v-else>
                                                {{$t(`notification_${item.action}`)}}
                                              </div>
                                            </div>
                                        </div>
                                      </el-tooltip>
                                    </el-dropdown-item>
                                </div>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <!-- TODO -->
            <div @click="loadNotifications(10, 1, 'null')" class="notification__item with-badge">
                <el-badge v-if="companyLayout" :value="companyLayout.newMessageCount" :hidden="companyLayout.newMessageCount === 0" class="item">
                </el-badge>
                <el-tooltip effect="dark" :content="$t('header_title_chat')" placement="bottom">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/comment.svg" width="18px" alt="">
                    </el-button>
                </el-tooltip>
            </div>

            <!-- <MySettings/> -->

            <div @mouseenter="loadNotifications(7, 1, 'null')" class="notification__item with-badge" style="margin-left: 34px;">
                <el-dropdown :hide-on-click="false" @visible-change="dropdownVisibleChanged">
                    <el-button size="small">
                        <img src="@/assets/img/toolbar/bookmark.svg" width="18px" alt="">
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="drop-down-head" disabled><span>{{$t('header_title_bookmarks')}}</span></el-dropdown-item>
                        <el-dropdown-item divided><span></span></el-dropdown-item>
                        <el-tabs v-model="activeNotiTab" @tab-click="handleTabClickBookmarks" class="notification-tabs">
                            <el-tab-pane :label="$t('header_all')" name="0">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_bu')" name="businessUnits">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_e')" name="engagements">
                            </el-tab-pane>
                            <el-tab-pane :label="$t('header_project')" name="projects">
                            </el-tab-pane>
                        </el-tabs>
                        <div>
                            <el-dropdown-item v-if="bookmarkNotifications.length === 0" disabled class="empty-head"><span>{{$t('header_no_bookmarks')}}</span></el-dropdown-item>
                            <div v-else>
                                <el-dropdown-item class="line-select-bookmarks" v-for="item in bookmarkNotificationsList" :key="item.index">
                                    <div style="display:flex; width: 100%;" @click="gotToBookmark(item)">
                                        <div class="text-truncate-bookmark" v-html="item.name"></div>
                                        <div class="text-truncate-bookmark" v-html="item.tab"></div>
                                    </div>
                                  <el-button @click="removeBookmarkOpenModal(item)" class="close-btn" type="primary" icon="el-icon-close" circle plain size="mini" ></el-button>
                                </el-dropdown-item>
                                <infinite-loading
                                        @infinite="infiniteHandler">
                                    <div slot="no-more"></div>
                                    <div slot="no-results"></div>
                                </infinite-loading>
                            </div>
                        </div>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <!-- <MySettings/> -->

            <!-- <SelectLanguage style="margin-left: 0;"/> -->

            <div class="notification__q">
                <!-- <div @click="myProfile" class="notification__item">
                  <el-badge :value="0" hidden class="item">
                    <el-button size="small" circle>
                      <font-awesome-icon icon="user-circle"/>
                    </el-button>
                  </el-badge>
                </div> -->

                <!-- <div class="notification__item red" @click="exit">
                  <el-badge :value="0" hidden class="item">
                    <el-button size="small" circle>
                      <font-awesome-icon icon="power-off"/>
                    </el-button>
                  </el-badge>
                </div> -->

                <My @profile="myProfile" :supportNotificationCount="user.notifications && user.notifications.supportNotificationCount" />

            </div>

            <!-- <div class="full" v-on:click="toggleFullscreen">
              <img src="@/assets/img/toolbar/maximize.svg" width="18px" alt="">
              <i class="fas fa-compress"></i>
            </div> -->

            <div v-show="!fullscreen" class="notification__item with-badge" v-on:click="toggleFullscreen">
              <el-button size="small">
                <!-- <i class="el-icon-star-on"></i> -->
                <img src="@/assets/img/toolbar/maximize.svg" width="18px" alt="">
              </el-button>
            </div>
            <div v-show="fullscreen" class="notification__item with-badge" v-on:click="toggleFullscreen">
              <el-button size="small">
                <!-- <i class="el-icon-star-on"></i> -->
                <img src="@/assets/img/toolbar/minimize.svg" width="18px" alt="">
              </el-button>
            </div>
        </div>
        <!-- [ Notification ] end -->

        <!-- [ Modal button create company ] start -->
        <sweet-modal blocking ref="company" class="modal">
            <h1>Invite Company</h1>

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">
                <el-form-item prop="companyName">
                    <el-input placeholder="Company name" v-model="form.companyName"></el-input>
                </el-form-item>

                <el-form-item prop="email">
                    <el-input v-model="form.email" placeholder="Email"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button @click="submitForm('form')" class="modal__btn" type="primary" plain size="small">Invite</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <!-- [ Modal button create company ] end -->

        <sweet-modal blocking ref="openInviteConfirmation">
            <!-- icons is an object containing SVG strings -->
            <div class="invite-modal">
                Hello,
                {{companyNameSelected}} would like to invite you.
            </div>
            <el-button slot="button" type="danger" plain @click="rejectNotification(ivitedNotificationId, 'deleteGeneral')">Reject</el-button>
            <el-button slot="button" type="success" @click="acceptNotification" plain>Accept</el-button>
        </sweet-modal>

        <sweet-modal blocking ref="openShareTaskConfirm">
            <!-- icons is an object containing SVG strings -->
            <div class="share-task-modal">
                {{$t('modal_inviteUser_hello')}},
                {{fromUserName}} {{$t('modal_inviteUser_wouldLikeToShare')}} {{taskName}} {{$t('modal_inviteUser_taskWithYou')}}<br>
            </div>
            <el-button slot="button" type="danger" plain @click="$refs.nestedChildSharing.open()">{{$t('general_reject')}}</el-button>
            <el-button slot="button" type="success" @click="acceptNotificationSharing" plain>{{$t('general_accept')}}</el-button>
        </sweet-modal>

        <sweet-modal class="share-task-modal" ref="nestedChildSharing">
            {{$t('modal_inviteUser_areYouSure')}},
            <el-button slot="button" type="danger" @click="rejectNotificationSharing(ivitedNotificationId, 'deleteGeneral')" plain>{{$t('general_reject')}}</el-button>
        </sweet-modal>

        <!-- [ Modal form My Profile ] start -->
        <myProfile ref="modal"/>
        <!-- [ Modal form My Profile ] end -->

        <chatComponent2 ref="chat2" />
        <meeting-calendar ref="meetingCalendar" @meetingEventClick="meetingEventClick"/>
        <expenseInfoModal @deleteNotification="deleteNotification" ref="expenseInfoModal" @refreshUserPage="refreshUserPage" @refreshExpensePage="refreshExpensePage"/>
        <cashAdvanceInfoModal @deleteNotification="deleteNotification" ref="cashAdvanceInfoModal" @refreshCashAdvancePage="refreshCashAdvancePage"/>
        <accountedCashAdvanceInfoModal @deleteNotification="deleteNotification" ref="accountedCashAdvanceInfoModal" @refreshCashAdvancePage="refreshCashAdvancePage"/>
        <AddProgressNote ref="modal3" :activeProjectId="projectId" :selectedRow="selectedRow" :stopTime="stopTime"/>
        <AddProgressNoteDep ref="modal4" :activeProjectId="projectId" :selectedRow="selectedRow" :stopTime="stopTime"/>
        <Progress ref="modal666" :activeProjectId="activeProjectId" :stopTime="stopTime" :progress="progress" :activityList="activityList" :assignmentList="assignmentList" @submit="refreshTreeAfterDeleteTimer"/>
        <ProgressDep ref="modal777" :activeProjectId="activeDepId" :stopTime="stopTime" :progress="progress" @submit="refreshTreeAfterDeleteTimer"/>
        <ProgressEngagement ref="modal888" :activeProjectId="activeEngagementId" :stopTime="stopTime" :progress="progress" @submit="refreshTreeAfterDeleteTimer"/>
        <PurchaseRequest  ref="purchaseRequest" @refreshPurchase="refreshPurchase"/>
        <VendorInvoiceRequest  ref="vendorInvoiceRequest" @refreshVendorInvoiceRequest="refreshVendorInvoiceRequest"/>
        <header-document-modal ref="headerDocumentModal"/>
        <!--<audio></audio>-->

        <Feedback ref="modal"/>
        <sweet-modal blocking ref="helpModal" :title="helpItem.title">
          <div v-html="helpItem.html">

          </div>
        </sweet-modal>
    </div>
    <!-- [ Header ] end -->

</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import log from '@/log/log.js'
  import { mapGetters } from 'vuex'
  import Progress from '@/components/Projects/progress/Progress.vue'
  import ProgressDep from '@/components/BusinessUnits/progress/Progress.vue'
  import ProgressEngagement from '@/components/Engagements/progress/Progress.vue'
  import PurchaseRequest from '@/components/purchases/purchaseRequestModal.vue'
  import VendorInvoiceRequest from '@/components/vendorInvoices/vendorRequestInvoiceInfoModal.vue'
  import AddProgressNote from '@/components/Projects/progress/AddProgressNote.vue'
  import AddProgressNoteDep from '@/components/BusinessUnits/progress/AddProgressNote.vue'
  import MySettings from '@/components/notifications/MySettings.vue'
  import MyProfile from '@/components/notifications/MyProfile.vue'
  import My from '@/components/notifications/My.vue'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  import NotificationBell from 'vue-notification-bell'
  import SelectLanguage from '@/components/SelectLanguage.vue'
  import expenseInfoModal from '@/components/expenses/expenseInfoModal.vue'
  import cashAdvanceInfoModal from '@/components/cash-davances/cashAdvanceInfoModal.vue'
  import accountedCashAdvanceInfoModal from '@/components/cash-davances/accountantCashAdvanceInfoModal.vue'
  import chatComponent2 from '@/components/chat/chatComponent2.vue'
  import Feedback from '@/components/Feedback.vue'
  // import { VueEditor } from 'vue2-editor'
  import MeetingCalendar from "../../components/meetingCalendar";
  import HeaderDocumentModal from "../../components/notifications/HeaderDocumentModal";
  import Vue2CustomEditor from "../../components/vue-2-custom-editor";
  import YourOrganizationDropDown from "./yourOrganization/index";
  import SupportDropdown from "./SupportDropdown";

  let moment = require('moment');
  export default {
    name: 'mainHeader',
    components: {
        SupportDropdown,
        YourOrganizationDropDown,
      Vue2CustomEditor,
      HeaderDocumentModal,
      MeetingCalendar,
      SweetModal,
      VendorInvoiceRequest,
      MySettings,
      MyProfile,
      My,
      SelectLanguage,
      NotificationBell,
      PurchaseRequest,
      accountedCashAdvanceInfoModal,
      AddProgressNote,
      AddProgressNoteDep,
      Progress,
      ProgressDep,
      ProgressEngagement,
      expenseInfoModal,
      cashAdvanceInfoModal,
      chatComponent2,
      Feedback,
      // VueEditor,
      InfiniteLoading
    },
    props: {
      // open: {
      //   type: Boolean,
      //   required: true
      // }
    },
    data() {
      return {
        // supportPage: [],
        fullscreen: false,
        tempSharedProjectTaskId: '',
        fromUserName: '',
        taskName: '',
        // audio: '',
        activityList: [],
        assignmentList: [],

        activeNotiTab: 'null',
        stages: [],
        activeTabStages: '0',
        stopTime: '00:00',
        progress: 0,
        projectId: 0,
        activeProjectId: 0,

        activeDepId: 0,
        activeEngagementId:0,
        selectedRow: {
          progress: ''
        },
        activeListTab: 'businessUnits',
        activeListTabTasks: 'businessUnits',
        activeListTabTimers: 'businessUnits',
        myProjectList: [],
        myEngagementList: [],
        myBusinessUnitList:[],
        myProjectTaskList:[],
        myProjectTaskListModal: [],
        myBusinessUnitTaskList:[],
        myEngagementTaskList:[],
        myTimerList:[],
        myTimerListDep:[],
        myTimerListEngagement:[],
        invitedCompanyid: '',
        invitedEmail: '',
        invitedHash: '',
        ivitedNotificationId: '',
        companyNameSelected: '',
        moment:moment,
        notifications:[],
        financeNotifications:[],
        generalNotifications:[],
        taskProgressNotifications:[],
        // taskProgressNotificationsList:[],
        commentNotifications:[],
        // commentNotificationsList:[],
        messageNotifications:[],
        // messageNotificationsList:[],
        meetingsNotifications: [],
        reminderNotifications:[],
        // reminderNotificationsList:[],
        documentNotifications:[],
        // documentNotificationsList:[],
        bookmarkNotificationsList:[],
        bookmarkNotifications:[],
        countNotifications: 0,
        valueCompany: '',

        // menu: true,

        // Invite
        form: {
          companyName: '',
          email: ''
        },
        rules: {
          companyName: [
            { required: true, message: this.$i18n.t('modal_inviteUser_pleaseInputActivityCompanyName'), trigger: 'blur' },
            { min: 5, message: this.$i18n.t('modal_inviteUser_lengthShouldBe5'), trigger: 'blur' }
          ],
          email: [
            { required: true, message: this.$i18n.t('modal_inviteUser_pleaseInputEmailAddress'), trigger: 'blur' },
            { type: 'email', message: this.$i18n.t('modal_inviteUser_pleaseInputCorrectEmailAddress'), trigger: 'blur' }
          ],
        },
        // varIsExitClick:false

        // formFeedback: {
        //   type: 0,
        //   message: '',
        //   subject: ''
        // },
        //
        // rulesFeedback: {
        //   subject: [{
        //     required: true,
        //     message: this.$i18n.t('modal_feedback_subjectIsRequired'),
        //     trigger: 'change'
        //   }],
        // },
        notificationId: null,
        nextPage: null,
        // notificationList: []
        helpList: [],
        helpItem: {}
      }
    },
    beforeCreate(){
      // this.$store.dispatch('loadUser')
      // this.$store.dispatch('setMyFirstCompanys')
    },
    created() {
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //   .post('/api/v1/users/itemMe')
      //   .then(response => {
      //     console.log('---P', response.data);
      //
      //   })
      //   .catch(error => {
      //     console.log('An error occurred:', error);
      //     loader.hide()
      //   });

      // if (!localStorage.getItem('companyId')) {
      //   localStorage.setItem('companyId', this.myFirstCompanys[0].id);
      //   // this.valueCompany = this.myFirstCompanys[0].name
      // }
      // // this.valueCompany = this.myFirstCompanys[0].name
      // console.log('---', this.myFirstCompanys[0].name);

      if (!sessionStorage.getItem('token')){
        this.$router.push({name: 'login'})
      }
      // this.$store.dispatch('loadUser').then(resp => {
      //   console.log('my resp22', resp)
      //   resp.companyList.forEach(val =>{
      //     if (val.id.toString() === this.$route.query.companyId){
      //       this.$store.dispatch('toggleActiveCompanyName', val.name);
      //     }
      //   })
      // })
    },
    sockets: {
      connect() {
        console.log('socket connected', this.$socket);
        // RECONNECT TO COMPANY ACTIVE FIX IT WHEN LOG IN
        this.$store.dispatch('loadUser').then(resp => {
          console.log('my resp22', resp);
          console.log('this.$route.query.companyId',this.$route.query.companyId)
          resp.companyList.forEach(val =>{
            if (val.id.toString() === this.$route.query.companyId.toString()){
              this.$store.dispatch('toggleActiveCompanyName', val.name);
            }
          })
        });
        if(this.$route.query.companyId){
          this.$store.dispatch('getCompanyLayout').then(response => {
            console.log('companyUserId3434', response)
            let data = {
              companyId: this.$route.query.companyId,
              companyUserId: response.companyUserId
            }
            this.$socket.emit('companyChanged', data)
          })
        }
      },
      customEmit(val) {
        console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
      },
      disconnect() {
        // if(sessionStorage.getItem('token')){
        // alert("sockets disconected")
        // this.$socket.open(this.$socket.query.token = sessionStorage.getItem('token'))
        // }
        console.log("socket disconnected...")
        // if(!this.varIsExitClick){
        //   this.notificationDisc("Error", "Connection Lost.", "error", 0)
        // }
        // this.varIsExitClick = false
      }
    },
    computed: {
      ...mapGetters([
        'getStateId', 'getNotificationDuration', 'getSubscription'
      ]),
      sidebarOpened() {
        return this.$store.state.sidebar.opened
      },
      user() {
        return this.$store.state.user
      },
      activeCompanyName() {
        return this.$store.state.activeCompanyName
      },
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
      // title: function () {
      //   return (this.formFeedback.type === 0) ? this.$t('modal_feedback') :
      //         (this.formFeedback.type === 1) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_feedback')}` :
      //         (this.formFeedback.type === 2) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_error')}` :
      //         (this.formFeedback.type === 3) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_help')}` :
      //         (this.formFeedback.type === 4) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_enquiries')}` :
      //         (this.formFeedback.type === 5) ? `${this.$t('modal_feedback')} / ${this.$t('modal_feedback_accounting_issues')}` : this.$t('modal_feedback')
      //
      // }
      // myFirstCompanys() {
      //   return this.$store.state.myCompanys
      // }
    },
    mounted(){
      var audio = new Audio(require('../../components/to-the-point.ogg'));
      this.$store.dispatch('loadUser').then(resp => {
          resp.companyList.forEach(val =>{
            if (val.id.toString() === this.$route.query.companyId){
              this.$store.dispatch('toggleActiveCompanyName', val.name);
            }
          })
      });
      if (sessionStorage.getItem('token')){
        this.$socket.open(this.$socket.query.token = sessionStorage.getItem('token'));
      }
      // NOTIFICATIONS
      this.$options.sockets.notificationCount = (data) => {
        if(data.action === 'create'){
          // this.$message('You have a notification.')
          this.notification(this.$t('modal_notifications_info'), this.$t('modal_notifications_youHaveNotification'), "info");
          audio.play()
        }
        this.user.notifications.taskProgressNotificationCount = data.taskProgressNotificationCount;
        this.user.notifications.financeNotificationCount = data.financeNotificationCount;
        this.user.notifications.generalNotificationCount = data.generalNotificationCount;
        this.user.notifications.commentNotificationCount = data.commentNotificationCount;
        this.user.notifications.messageNotificationCount = data.messageNotificationCount;
        this.user.notifications.reminderNotificationCount = data.reminderNotificationCount;
        this.user.notifications.documentNotificationCount = data.documentNotificationCount;
        this.user.notifications.meetingNotificationCount = data.meetingNotificationCount;
        this.user.notifications.supportNotificationCount = data.supportNotificationCount;
        // TODO: test
        this.user.notifications.timerNotificationCount = data.timerNotificationCount
      }
      // CHAT MESSAGES COUNT
      this.$options.sockets.event = (data) => {
        // Check if that company selected
        if (this.$route.query.companyId == data.companyId) {
          if (data.action === 'companyUserChatMessage' || data.action === 'markCompanyUserChatMessageAsRead'){
            if (data.params.newCompanyUserMessageGroupList.length > 0){
              let countMessages = 0;
              data.params.newCompanyUserMessageGroupList.forEach( val => {
                countMessages += val.newMessageCount
              });
              this.companyLayout.newMessageCount = countMessages
            }else{
              this.companyLayout.newMessageCount = 0
            }
          }
        }
      }
      // CHAT MESSAGES NOTIFICATIONS // MEETING MODAL NOTIFICATION
      this.$options.sockets.event = (data) => {
        if(data.action === 'companyChatMessage' || data.action === 'companyUserChatMessage'){
          if(this.$route.query.companyId == data.companyId){
              audio.play()
            if(this.$refs['chat2'].companyUserId !== data.params.fromCompanyUserId && data.action !== 'companyChatMessage') {
              const userBackground = require('../../assets/img/user-default.jpg')
              let card = `<div style='display:flex; align-items: center; width: 255px;'>` +
                `<div style='background:${'url(' + userBackground + ');'} background-size: cover; border-radius: 50%; width: 50px; height: 50px; overflow: hidden; min-width: 50px; margin-right: 10px;' ><img style='width: 50px; height: 50px; border-radius: 50%; background-size: cover;' src="${data.params.fromUserAvatarUrl || userBackground}"></div> \n` +
                `<div>` + data.params.fromUserFullName + `</div> \n` +
                `</div> \n` +
                `<div> \n` +
                `<h4 style='line-height: 10px;'>Message: </h4>` +
                `<div style='width: 255px; overflow: hidden; text-overflow: ellipsis;'>` + data.params.message + `</div>` +
                `</div>`

              this.notification("You have a message", card, "info");
            }

            if(this.$refs['chat2'].companyUserId !== 'group' && data.action === 'companyChatMessage'){
              const userBackground = require('../../assets/img/group.png')
              let card =  `<div style='display:flex; align-items: center; width: 255px;'>` +
                `<div style='background:${'url(' + userBackground + ');'} background-size: cover; border-radius: 50%; width: 50px; height: 50px; overflow: hidden; min-width: 50px; margin-right: 10px;' ><img style='width: 50px; height: 50px; border-radius: 50%; background-size: cover;' src="${data.params.userAvatarUrl || userBackground}"></div> \n` +
                `<div>`  + data.params.userFullName + `</div> \n` +
                `</div> \n` +
                `<div> \n` +
                `<h4 style='line-height: 10px;'>Message: </h4>` +
                `<div style='width: 255px; overflow: hidden; text-overflow: ellipsis;' >` + data.params.message + `</div>` +
                `</div>`
              this.notification("You have a group message", card, "info");
            }

          }
        }

        if (data.action === 'deactivate_company_user') {
          this.notification("Notification", 'You have been deactivated by this company', "info")
          this.exitDeactivated()
          // console.log('deactivate_company_user deactivate_company_user deactivate_company_user deactivate_company_user deactivate_company_user 99999999999099999999')
        }

        if (data.action === 'onlyofficeStatus' || data.action === 'onlyofficeEditStatus') {
          // file successfully saved
          if (data.params.status === 2) {
            this.notification(this.$t('general_success'), this.$t('file_fileSuccessfullySaved'), "success");
            this.$store.dispatch('hideFileNotification', 500);
            // file successfully not saved
          } else if (data.params.status === 4) {
            this.notification(this.$t('general_warning'), this.$t('file_fileNotSaved'), "info");
            this.$store.dispatch('hideFileNotification', 500);
          }

          if (data.params.status !== 1) {
            switch (data.params.entityTypeId) {
              case 27:
                if (this.$route.name === 'projects' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.taskId.toString() === data.params.entityId.toString()) {
                  this.$store.dispatch('getTaskFiles', data.params.entityId);
                }
                break;
              case 3:
                if (this.$route.name === 'projects' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.projectId.toString() === data.params.entityId.toString()) {
                  this.$store.dispatch('getProjectFiles');
                }
                break;
              case 45:
                if (this.$route.name === 'business-units' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.taskId.toString() === data.params.entityId.toString()) {
                  this.$store.dispatch('getDepTaskFiles', data.params.entityId)
                }
                break;
              case 19:
                if (this.$route.name === 'business-units' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.businessUnitId.toString() === data.params.entityId.toString())  {
                  this.$store.dispatch('getBusinessUnitFiles')
                }
                break;
              case 37:
                if (this.$route.name === 'engagements' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.taskId.toString() === data.params.entityId.toString()) {
                  this.$store.dispatch('getCasTaskFiles', data.params.taskId)
                }
                break;
              case 11:
                if (this.$route.name === 'engagements' &&
                  this.$route.query.companyId.toString() === data.params.companyId.toString() &&
                  this.$route.query.engagementId.toString() === data.params.entityId.toString()) {
                  this.$store.dispatch('getEngagementFiles')
                }
                break;
            }
          }
        }
        if (data.action === 'defaultReminder') {
          let myAction = ''
          // project task
          // if (data.params.meeting.projectId && data.params.meeting.projectTaskId) {
          //   myAction = 'approveProjectTaskMeetings'
          // }
          // // project
          // if (data.params.meeting.projectId && !data.params.meeting.projectTaskId) {
          //   myAction = 'customReminderProjectMeeting'
          // }
          // // bu task
          // if (data.params.meeting.businessUnitId && data.params.meeting.businessUnitTaskId) {
          //   myAction = 'approveBusinessUnitTaskMeetings'
          // }
          // // bu
          // if (data.params.meeting.businessUnitId && !data.params.meeting.businessUnitTaskId) {
          //   myAction = 'approveBusinessUnitMeetings'
          // }
          // // eng task
          // if (data.params.meeting.engagementId && data.params.meeting.engagementTaskId) {
          //   myAction = 'approveEngagementTaskMeetings'
          // }
          // // eng
          // if (data.params.meeting.engagementId && !data.params.meeting.engagementTaskId) {
          //   myAction = 'approveEngagementMeetings'
          // }
          switch (data.params.meeting.typeId) {
            case 1:
              myAction = 'createProjectMeetings'
              break;
            case 4:
              myAction = 'createProjectTaskMeetings'
              break;
            case 2:
              myAction = 'createBusinessUnitMeeting'
              break;
            case 5:
              myAction = 'createBusinessUnitTaskMeeting'
              break;
            case 3:
              myAction = 'createEngagementMeeting'
              break;
            case 6:
              myAction = 'createEngagementTaskMeeting'
              break;
          }
          if (data.action === 'defaultReminder') {
            this.openModalMeetingReminder(
                data.companyId,
                data.params.meeting.parentId,
                data.params.meeting.taskId,
                data.params.meeting.id,
                data.params.companyName,
                myAction,
                data.params.meeting.typeId === 1 || data.params.meeting.typeId === 4 ? 'projects' : data.params.meeting.typeId === 2 || data.params.meeting.typeId === 5 ? 'business-units' : 'engagements',
                data.params.parentName,
                data.params.taskName,
                data.params.meeting.name,
                data.params.meeting.startTimestamp,
                data.action,
                data.params.meeting.roomVideoId)
          }
        }
        if (data.action === 'openMeeting'){
          this.openModalStartMeeting(
              data.companyId,
              data.params.meeting.parentId,
              data.params.meeting.taskId,
              data.params.meeting.id,
              data.params.companyName,
              data.params.meeting.typeId === 1 || data.params.meeting.typeId === 4 ? 'projects' : data.params.meeting.typeId === 2 || data.params.meeting.typeId === 5 ? 'business-units' : 'engagements',
              data.params.parentName,
              data.params.taskName,
              data.params.meeting.name,
              data.params.meeting.startTimestamp,
              // data.action,
              data.params.meeting.roomVideoId,
              data.params.meeting.typeId)
        }
        if (data.action === 'openMeetingHost') {
          this.openModalStartHostMeeting(
              data.companyId,
              data.params.meeting.parentId,
              data.params.meeting.taskId,
              data.params.meeting.id,
              data.params.companyName,
              data.params.meeting.typeId === 1 || data.params.meeting.typeId === 4 ? 'projects' : data.params.meeting.typeId === 2 || data.params.meeting.typeId === 5 ? 'business-units' : 'engagements',
              data.params.parentName,
              data.params.taskName,
              data.params.meeting.name,
              data.params.meeting.startTimestamp,
              // data.action,
              data.params.meeting.roomVideoId,
              data.params.meeting.typeId)
        }
      }

      this.$options.sockets.companyInternalEvent = (data) => {
        if (data.action === 'meetingAgendaEvent' || data.action === 'meetingFileEvent') {
          if (this.$route.query.companyId.toString() === data.companyId.toString()) {
            if (this.$route.name === 'projects' && this.$route.query.projectId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === '0'  && !data.taskId ||
                this.$route.name === 'projects' && this.$route.query.projectId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === data.taskId.toString() ||
                this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === '0'  && !data.taskId ||
                this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === data.taskId.toString() ||
                this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === '0'  && !data.taskId ||
                this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === data.parentId.toString() && this.$route.query.taskId.toString() === data.taskId.toString()
            ) {
              this.$store.dispatch('getMeetings', {
                companyId: data.companyId,
                parentId: data.parentId,
                taskId: data.taskId,
                typeId: data.typeId})
            }
          }
        }
      }

      // let loader = this.$loading.show();
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      // axios
      //   .post(`/api/v1/support-page/list`)
      //   .then(response => {
      //     this.supportPage = response.data.list
      //     loader.hide()
      //   })
      //   .catch(error => {
      //     console.log('An error occurred:', error);
      //     loader.hide()
      //   })
    },
    methods: {
      exitDeactivated() {
        // Log logout
        log(`/api/v1/logs/create?companyId=${this.$route.query.companyId}`, {
          'action': 'log_logout',
          'paramsLog': {}
        })

        this.$socket.close();
        // localStorage.clear()
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('vue-session-key');
        sessionStorage.removeItem('timer');
        localStorage.removeItem('selectedProjectId');
        // localStorage.removeItem('companyName')
        localStorage.removeItem('companyId');
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        console.log('this.$route.fullPath', this.$route.fullPath);
        console.log('this.$route', this.$route);

        axios.post(`/api/v1/auth/logout`)
          .then(response => {})
          .catch(error => {})
      },
      // supportPageClick(url) {
      //   const newUrl = this.getValidUrl(url)
      //   window.open(newUrl)
      // },
      // modalCancel(ref) {
      //   this.$refs[ref].close();
      // },
      test(){
        console.log('this.$refs.aboutThisProject', this.$refs.feedbackEditor)
      },
      selectionChange(range, oldRange, source){
        console.log('selection range, oldRange, source', range, oldRange, source)
      },
      textChange(delta, oldDelta, source){
        console.log('text change ', delta, oldDelta, source)
      },
        routerLink(page) {
            this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
            this.$refs.dropdown.hide()
        },
      // selectedFeedback(type) {
      //   this.$refs['feedback'].open();
      //   this.formFeedback.type = type;
      //   this.formFeedback.message = '';
      //   this.formFeedback.subject = ''
      // },
      // closeModalFeedback() {
      //   this.formFeedback.type = 0;
      //   this.formFeedback.message = '';
      //   this.formFeedback.subject = ''
      // },
      // submitFormFeedback(form) {
      //   this.$refs[form].validate((valid) => {
      //     if (valid && this.formFeedback.message) {
      //       console.log('submit');
      //
      //       let loader = this.$loading.show();
      //       axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //       axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //       axios
      //         .post(`/api/v1/feedback/create?companyId=${this.$route.query.companyId}`, {
      //           subjectType: this.formFeedback.type,
      //           message: this.formFeedback.message,
      //           subject: this.formFeedback.subject
      //         })
      //         .then(response => {
      //           this.notification("Success", "Thank you for report", "success");
      //           this.formFeedback.message = ''
      //           this.formFeedback.subject = ''
      //           this.$refs.feedback.close();
      //           loader.hide()
      //           if (this.$refs.feedbackEditor.uploadedImagesArray.length) {
      //             this.$store.dispatch('approveUploadedImages', {
      //               fileUrlArr: this.$refs.feedbackEditor.uploadedImagesArray,
      //               entityId: response.data.feedbackId,
      //               entityTypeId: 52 // feedback
      //             })
      //           }
      //         })
      //         .catch(error => {
      //           console.log('An error occurred:', error);
      //           loader.hide()
      //         })
      //
      //     } else {
      //       console.log('error submit!!');
      //       return false;
      //     }
      //   });
      // },
      // sentsFeedback() {
      //   this.$refs['modal'].$refs['feedback'].open()
      // },
      refreshTreeAfterDeleteTimer(parentId, taskId){
        this.$emit('refreshTreeAfterDeleteTimer', parentId, taskId)
      },
      refreshPurchase(){
        this.$emit('refreshPurchase')
      },
      refreshVendorInvoiceRequest(){
        this.$emit('refreshVendorInvoiceRequest')
      },
      openChat2(){
          this.$refs.chat2.openChat()
      },
      closeChat2(){
          this.$refs.chat2.closeAll()
      },
      nameTimer(str) {
        if (str.length > 25) {
          return str.slice(0, 25) + '...'
        } else {
          return str
        }
      },
      // handleTabClick(tab, event) {
      //   if(tab.name === '0'){
      //     this.myProjectTaskListModal = this.myProjectTaskList
      //   }else{
      //     let myTaskList = [];
      //     this.myProjectTaskList.forEach(val => {
      //       if (val.companyStageId == tab.name){
      //         myTaskList.push(val)
      //       }
      //     })
      //     this.myProjectTaskListModal = myTaskList
      //   }
      // },
      // handleTabClickProgress(tab, event) {
      //   if (tab.name === '0') {
      //     this.taskProgressNotificationsList = this.taskProgressNotifications
      //   }else {
      //     this.taskProgressNotificationsList = this.filterNotifications(this.taskProgressNotifications, tab.name);
      //   }
      // },
      // handleTabClickComments(tab, event){
      //   if (tab.name === '0') {
      //     this.commentNotificationsList = this.commentNotifications
      //   }else {
      //     this.commentNotificationsList = this.filterNotifications(this.commentNotifications, tab.name);
      //   }
      // },
      // handleTabClickMessages(tab, event){
      //   if (tab.name === '0') {
      //     this.messageNotificationsList = this.messageNotifications
      //   }else {
      //     this.messageNotificationsList = this.filterNotifications(this.messageNotifications, tab.name);
      //   }
      // },
      // handleTabClickMeetings(tab, event) {
      //   if (tab.name === '0') {
      //     this.meetingsNotificationsList = this.meetingsNotifications
      //   }else {
      //     this.meetingsNotificationsList = this.filterNotifications(this.meetingsNotifications, tab.name);
      //   }
      // },
      // handleTabClickReminders(tab, event){
      //   if (tab.name === '0') {
      //     this.reminderNotificationsList = this.reminderNotifications
      //   }else {
      //     this.reminderNotificationsList = this.filterNotifications(this.reminderNotifications, tab.name);
      //   }
      // },
      // handleTabClickDocuments(tab, event){
      //   if (tab.name === '0') {
      //     this.documentNotificationsList = this.documentNotifications
      //   }else {
      //     this.documentNotificationsList  = this.filterNotifications(this.documentNotifications, tab.name);
      //   }
      // },
      // filterNotifications(notifications, type){
      //   const list = [];
      //   for (let i = 0; i < notifications.length; i++) {
      //     const parent = {
      //       dateCheck: notifications[i].dateCheck,
      //       arrayDate: []
      //     };
      //     switch (type) {
      //       case "businessUnits":
      //         parent.arrayDate = notifications[i].arrayDate.filter(bal => bal.params.businessUnitName);
      //         break;
      //       case "engagements":
      //         parent.arrayDate = notifications[i].arrayDate.filter(bal => bal.params.engagementName);
      //         break;
      //       case "projects":
      //         parent.arrayDate = notifications[i].arrayDate.filter(bal => bal.params.projectName);
      //         break;
      //     }
      //     if (parent.arrayDate.length){
      //       list.push(parent)
      //     }
      //   }
      //   return list
      // },
      dropdownVisibleChanged(val) {
        console.log('val-=-=-', val)
        if (!val) {
          this.activeNotiTab = 'null';
          // this.notificationId = null;
          this.nextPage = null;
          // reset noti arrays
          this.generalNotifications = [];
          this.taskProgressNotifications = [];
          this.financeNotifications = [];
          this.commentNotifications = [];
          this.messageNotifications = [];
          this.meetingsNotifications = [];
          this.reminderNotifications = [];
          this.documentNotifications = [];
        }
      },
      handleTabClickBookmarks(tab, event){
        let myTaskList = [];
        if(tab.name === '0'){
          this.bookmarkNotificationsList = this.bookmarkNotifications
        }else{
          this.bookmarkNotifications.forEach(val => {
            if(val.type ===  3 && tab.name === 'businessUnits' || val.type ===  4 && tab.name === 'businessUnits'){
              myTaskList.push(val)
            }else if(val.type ===  5 && tab.name === 'engagements' || val.type ===  6 && tab.name === 'engagements'){
              myTaskList.push(val)
            }else if(val.type ===  1 && tab.name === 'projects' || val.type ===  2 && tab.name === 'projects'){
              myTaskList.push(val)
            }
          });
          this.bookmarkNotificationsList = myTaskList
        }
      },
      // TIMER
      pauseTimer(id, projectId, projectTaskId) {
        console.log('---EEER', id, projectId, projectTaskId);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskTimers/pause?companyId=${this.$route.query.companyId}&projectId=${projectId}&projectTaskId=${projectTaskId}&projectTaskTimerId=${id}`)
          .then(response => {
            console.log('---/projectTaskTimers/pause', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            this.notification("Success", "Timer pause", "success");
            if(this.$route.name === 'projects' && this.$route.query.projectId == projectId && this.$route.query.taskId == projectTaskId){
              this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
            }else if(this.$route.name === 'shared-projects' && this.$route.query.projectId == projectId && this.$route.query.taskId == projectTaskId) {
              this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      pauseTimerDep(id, businessUnitId, businessUnitTaskId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskTimers/pause?companyId=${this.$route.query.companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${businessUnitTaskId}&businessUnitTaskTimerId=${id}`)
          .then(response => {
            console.log('---/businessUnitTaskTimers/pause', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            this.notification("Success", "Timer pause", "success");
            if(this.$route.name === 'business-units' && this.$route.query.businessUnitId == businessUnitId && this.$route.query.taskId == businessUnitTaskId){
              this.$store.dispatch('getTimerListDep', {businessUnitId: businessUnitId, businessUnitTaskId: businessUnitTaskId})
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      pauseTimerEngagement(id, engagementId, engagementTaskId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTaskTimers/pause?companyId=${this.$route.query.companyId}&engagementId=${engagementId}&engagementTaskId=${engagementTaskId}&engagementTaskTimerId=${id}`)
          .then(response => {
            console.log('---/engagementTaskTimers/pause', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            this.notification("Success", "Timer pause", "success");
            if(this.$route.name === 'engagements' && this.$route.query.engagementId == engagementId && this.$route.query.taskId == engagementTaskId){
              this.$store.dispatch('getTimerListCas', {engagementId: engagementId, engagementTaskId: engagementTaskId})
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      restartTimer(id, projectId, projectTaskId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskTimers/restart?companyId=${this.$route.query.companyId}&projectId=${projectId}&projectTaskId=${projectTaskId}&projectTaskTimerId=${id}`)
          .then(response => {
            console.log('---/projectTaskTimers/restart', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            this.notification("Success", "Timer restart", "success");
            if(this.$route.name === 'projects' && this.$route.query.projectId == projectId && this.$route.query.taskId == projectTaskId){
              this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
            }else if(this.$route.name === 'shared-projects' && this.$route.query.projectId == projectId && this.$route.query.taskId == projectTaskId){
              this.$store.dispatch('getTimerList', {projectId: projectId, projectTaskId: projectTaskId})
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      restartTimerDep(id, businessUnitId, businessUnitTaskId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskTimers/restart?companyId=${this.$route.query.companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${businessUnitTaskId}&businessUnitTaskTimerId=${id}`)
          .then(response => {
            console.log('---/businessUnitTaskTimers/restart', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            this.notification("Success", "Timer restart", "success");
            if(this.$route.name === 'business-units' && this.$route.query.businessUnitId == businessUnitId && this.$route.query.taskId == businessUnitTaskId){
              this.$store.dispatch('getTimerListDep', {businessUnitId: businessUnitId, businessUnitTaskId: businessUnitTaskId})
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      restartTimerEngagement(id, engagementId, engagementTaskId) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTaskTimers/restart?companyId=${this.$route.query.companyId}&engagementId=${engagementId}&engagementTaskId=${engagementTaskId}&engagementTaskTimerId=${id}`)
          .then(response => {
            console.log('---/engagementTaskTimers/restart', response.data);
            // this.$store.dispatch('getTimerList')
            this.getTimerList(this.$route.query.companyId)
            if(this.$route.name === 'engagements' && this.$route.query.engagementId == engagementId && this.$route.query.taskId == engagementTaskId) {
              this.$store.dispatch('getTimerListCas', {engagementId: engagementId, engagementTaskId: engagementTaskId})
            }
            this.notification("Success", "Timer restart", "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      totalTime(startTime, time, total) {
        let s
        if (startTime === null) {
          s = total
        } else {
          s =  time - startTime + total
        }

        let sec = s % 60
        let min = Math.floor((s / 60) % 60)
        let hour = Math.floor(s / 3600)

        if (sec.toString().length < 2) {
          sec = '0' + sec
        }
        if (min.toString().length < 2) {
          min = '0' + min
        }
        if (hour.toString().length < 2) {
          hour = '0' + hour
        }

        // this.time = hour + ':' + min + ':' + sec
        return hour + ':' + min
        //  + ':' + sec
      },
      stopTimer(id, startTime, time, total, projectTaskId, projectId, progress) {

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskProgresses/directories?companyId=${this.$route.query.companyId}&projectId=${projectId}&projectTaskId=${projectTaskId}&operation=create`)
          .then(response => {
            if (response.data.allowExternalNotifications === 1){
              this.allowNotification = false
            }else{
              this.allowNotification = true
              this.form.notifyClients = false
              this.form.notifyVendors = false
            }
            this.activityList = response.data.projectTaskProgressActivityList
            this.assignmentList = response.data.projectTaskProgressAssignmentList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/projectTaskTimers/preStop?companyId=${this.$route.query.companyId}&projectId=${projectId}&projectTaskId=${projectTaskId}&projectTaskTimerId=${id}`)
          .then(response => {
            console.log('---/projectTaskTimers/preStop', response.data);
            let s = response.data.data.totalTime

            let sec = s % 60
            let min = Math.floor((s / 60) % 60)
            let hour = Math.floor(s / 3600)

            if (sec.toString().length < 2) {
              sec = '0' + sec
            }

            if (min.toString().length < 2) {
              min = '0' + min
            }
            if (hour.toString().length < 2) {
              hour = '0' + hour
            }

            this.stopTime = hour + ':' + min
            this.progress = Math.round(response.data.data.progress)
            this.activeProjectId = projectId

            this.$refs.modal666.projectTaskId = projectTaskId
            this.$refs.modal666.projectTaskTimerId = id;
            this.$refs.modal666.$refs['createProjectTaskProgress'].open();
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

      },
      stopTimerDep(id, startTime, time, total, businessUnitTaskId, businessUnitId, progress) {

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/businessUnitTaskTimers/preStop?companyId=${this.$route.query.companyId}&businessUnitId=${businessUnitId}&businessUnitTaskId=${businessUnitTaskId}&businessUnitTaskTimerId=${id}`)
          .then(response => {
            console.log('---/businessUnitTaskTimers/preStop', response.data);
            let s = response.data.data.totalTime

            let sec = s % 60
            let min = Math.floor((s / 60) % 60)
            let hour = Math.floor(s / 3600)

            if (sec.toString().length < 2) {
              sec = '0' + sec
            }
            if (min.toString().length < 2) {
              min = '0' + min
            }
            if (hour.toString().length < 2) {
              hour = '0' + hour
            }

            this.stopTime = hour + ':' + min
            this.progress = Math.round(response.data.data.progress)
            this.activeDepId = businessUnitId

            this.$refs.modal777.depTaskId = businessUnitTaskId;
            this.$refs.modal777.depTaskTimerId = id;
            this.$refs.modal777.$refs['createProjectTaskProgress'].open();
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      stopTimerEngagement(id, startTime, time, total, engagementTaskId, engagementId, progress) {

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTaskTimers/preStop?companyId=${this.$route.query.companyId}&engagementId=${engagementId}&engagementTaskId=${engagementTaskId}&engagementTaskTimerId=${id}`)
          .then(response => {
            console.log('---/engagementTaskTimers/preStop', response.data);
            let s = response.data.data.totalTime

            let sec = s % 60
            let min = Math.floor((s / 60) % 60)
            let hour = Math.floor(s / 3600)

            if (sec.toString().length < 2) {
              sec = '0' + sec
            }
            if (min.toString().length < 2) {
              min = '0' + min
            }
            if (hour.toString().length < 2) {
              hour = '0' + hour
            }

            this.stopTime = hour + ':' + min
            this.progress = Math.round(response.data.data.progress)
            this.activeEngagementId = engagementId

            this.$refs.modal888.depTaskId = engagementTaskId;
            this.$refs.modal888.depTaskTimerId = id;
            this.$refs.modal888.$refs['createProjectTaskProgress'].open();
            // this.$store.dispatch('getTimerListCas')
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getList(state){
        if(state === 'list'){
          this.getBusinessUnitList(this.$route.query.companyId)
          this.getProjectList(this.$route.query.companyId)
          this.getEngagementList(this.$route.query.companyId)
        }else if(state === 'taskList'){
          this.getProjectStages()
          this.getTaskList(this.$route.query.companyId)
          this.getTaskListDep(this.$route.query.companyId)
          this.getTaskListEngagement(this.$route.query.companyId)
        }else if(state === 'timerList'){
          this.getTimerList(this.$route.query.companyId)
        }
      },
      getProjectList(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projects/list?companyId=${id}`)
          .then(response => {
            this.myProjectList = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getEngagementList(id){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagements/list?companyId=${id}`)
          .then(response => {
            this.myEngagementList = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getBusinessUnitList(id) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/businessUnits/listExistUser?companyId=${id}`)
          .then(response => {
            this.myBusinessUnitList = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getTaskList(id) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTasks/myList?companyId=${id}`)
          .then(response => {
            this.myProjectTaskList = response.data.myList
            this.myProjectTaskListModal = response.data.myList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getTaskListDep(id){
        // Dep
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTasks/myList?companyId=${id}`)
          .then(response => {
            this.myBusinessUnitTaskList = response.data.myList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getTaskListEngagement(id){
        // Engagement
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagementTasks/myList?companyId=${id}`)
          .then(response => {
            this.myEngagementTaskList = response.data.myList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getTimerList(id) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTaskTimers/myList?companyId=${id}`)
          .then(response => {

            let list = response.data.myList;

            for (let i = 0; i < list.length; i++ ){
              list[i].time = response.data.timestamp
            }

            this.myTimerList = list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });

        // Dep
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTaskTimers/myList?companyId=${id}`)
          .then(response => {

            let list = response.data.myList;

            for (let i = 0; i < list.length; i++ ){
              list[i].time = response.data.timestamp
            }

            this.myTimerListDep = list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        // Engagements
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagementTaskTimers/myList?companyId=${id}`)
          .then(response => {

            let list = response.data.myList;

            for (let i = 0; i < list.length; i++ ){
              list[i].time = response.data.timestamp
            }

            this.myTimerListEngagement = list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      setToPointDep(companyId, businessUnitId, notificationType){
        // localStorage.setItem('companyId', companyId);
        // localStorage.setItem('selectedBusinessUnitId', businessUnitId);
        if(this.$route.name !== 'business-units'){
          this.$router.push({path: 'business-units', query: {companyId: companyId, businessUnitId: businessUnitId, tabName: notificationType }} )
        }else{
          this.$router.push({query: {companyId: companyId, businessUnitId: businessUnitId, taskId: '0' }} ).then(res => {
              this.$emit('setProjectRowDataInput', businessUnitId);
              this.$emit('setActiveTabs', notificationType)
          }).catch(err =>{
              this.$emit('setProjectRowDataInput', businessUnitId);
              this.$emit('setActiveTabs', notificationType)
          })
          // this.$route.query.businessUnitId = businessUnitId
        }
      },
      setToPointProj(companyId, projectId, notificationType){
        // localStorage.setItem('companyId', companyId)
        // localStorage.setItem('selectedProjectId', projectId)
        // alert(notificationType)
        if(this.$route.name !== 'projects'){
          this.$router.push({name: 'projects', query: { companyId: companyId, projectId: projectId, taskId: '0', tabName: notificationType }} )
          // this.$router.push('/')
        }else{
            // bookmarks always be here becouse its always in same company works
            this.$router.push({query: { companyId: companyId, projectId: projectId, taskId: '0'}} ).then(res => {
            this.$emit('setProjectRowDataInput', projectId);
            this.$emit('setActiveTabs', notificationType)
          }).catch(err =>{
                this.$emit('setProjectRowDataInput', projectId);
                this.$emit('setActiveTabs', notificationType)
            })
          // this.$emit('setProj', 'first')
          // this.$emit('setActiveTabs')
        }
      },
      setToPointEngagement(companyId, engagementId, notificationType){
        // localStorage.setItem('companyId', companyId)
        // localStorage.setItem('selectedEngagementId', engagementId)
        if(this.$route.name !== 'engagements'){
          this.$router.push({path: 'engagements', query: { companyId: companyId, engagementId: engagementId, taskId: 0, tabName: notificationType}} )
        }else{
            this.$router.push({name: 'engagements',query: { companyId: companyId, engagementId: engagementId, taskId: 0}} ).then(res => {
                this.$emit('setProjectRowDataInput', engagementId);
                this.$emit('setActiveTabs', notificationType)
            }).catch(err =>{
                this.$emit('setProjectRowDataInput', engagementId);
                this.$emit('setActiveTabs', notificationType)
            })
        }
      },
      setToPointTask(companyId, projectId, taskId, type, notificationType, stateId){
        // alert('123')
        localStorage.setItem('companyId', companyId);
        if(type === 'projectTask'){
          localStorage.setItem('selectedProjectTaskId', taskId)
        }
        if(type === 'businessUnitTask'){
          localStorage.setItem('selectedBusinessUnitId', projectId)
        }
        if(type === 'engagementTask'){
          localStorage.setItem('selectedEngagementId', projectId)
        }
        if(this.$route.name !== 'projects' && type === 'projectTask'){
          localStorage.setItem('selectedProjectId', projectId);
          this.$router.push({path: '/projects', query: { companyId: companyId, projectId: projectId, taskId: taskId, state: type, stateId: stateId, tabName: notificationType }} )
          // this.$router.push('/')
        }else if(this.$route.name === 'projects' && type === 'projectTask'){
          this.$router.push({query: { companyId: companyId, projectId: projectId, taskId: taskId }} );
          this.$emit('setProjectTaskRowDataInput', projectId, false, taskId);
          this.$emit('setActiveTabs', notificationType, stateId)

        }else if(this.$route.name !== 'business-units' && type === 'businessUnitTask'){
          localStorage.setItem('selectedBusinessUnitTaskId', taskId)
          this.$router.push({path: 'business-units', query: { companyId: companyId, businessUnitId: projectId, taskId: taskId, state: type, tabName: notificationType }} )
          // this.$router.push('/business-units')
          // console.log('DEPcompanyId', companyId, 'DEPprojectId', projectId, 'DEptaskId',taskId)
        }else if(this.$route.name === 'business-units' && type === 'businessUnitTask'){
          localStorage.setItem('selectedBusinessUnitTaskId', taskId)
          this.$router.push({query: { companyId: companyId, businessUnitId: projectId, taskId: taskId }} )
            this.$emit('setProjectTaskRowDataInput', projectId, false, taskId)
            this.$emit('setActiveTabs', notificationType, stateId)
        }else if(this.$route.name !== 'engagements' && type === 'engagementTask'){
          localStorage.setItem('selectedEngagementTaskId', taskId)
          this.$router.push({path: 'engagements', query: { companyId: companyId, engagementId: projectId, taskId: taskId, state: type, tabName: notificationType }} )
        }else if(this.$route.name === 'engagements' && type === 'engagementTask'){
          localStorage.setItem('selectedEngagementTaskId', taskId)
          this.$router.push({query: { companyId: companyId, engagementId: projectId, taskId: taskId }} )
            this.$emit('setProjectTaskRowDataInput', projectId, false, taskId)
            this.$emit('setActiveTabs', notificationType, stateId)
        }
        // this.$emit('setShared', projectId, 'infoProjectTask', taskId, companyId)
        console.log(companyId, projectId, taskId)
      },
      async gotToBookmark(item){
        try {
          console.log(item, 'item')
          // return console.log('MA ITEM', item);
          const userAccess = await this.checkUserAccess(
              item.companyId,
              item.projectId || item.businessUnitId || item.engagementId,
              item.id || null,
              item.projectId ? 'projects' : item.businessUnitId ? 'business-units' : 'engagements',
              'bookmark',
              1,
              null,
              null)

          // check if task deleted
          if (item.id && !userAccess.notDeleted) {
            return this.openNoAccessModalBookmark(this.$t('notification_taskRemovedDeleteBookmark'), item.bookmarkId)
          }
          // check if user has access to task
          if (item.id && !userAccess.hasAccessTask) {
            return this.openNoAccessModalBookmark(this.$t('notification_youNotPresentInTheTaskTeamDeleteBookmark'), item.bookmarkId)
          }
          // check if parent deleted
          if (!item.id && !userAccess.notDeleted) {
            return this.openNoAccessModalBookmark(
                item.projectId ? this.$t('notification_checkUser_projectWasDeletedDeleteBookmark')
                    : item.businessUnitId ? this.$t('notification_checkUser_businessUnitWasDeletedDeleteBookmark')
                    : this.$t('notification_checkUser_engagementWasDeletedDeleteBookmark') , item.bookmarkId)
          }
          // check if user has access to parent
          if (!item.id && !userAccess.hasAccessParent) {
            return this.openNoAccessModalBookmark(
                item.projectId ? this.$t('notification_youAreNotPartOfThisProjectteamDeleteBookmark')
                    : item.businessUnitId ? this.$t('notification_youAreNotPartOfThisBusinessUnitteamDeleteBookmark')
                    : this.$t('notification_youAreNotPartOfThisEngagementTeamDeleteBookmark'), item.bookmarkId)
          }

          console.log('userAccess', userAccess)

          switch (item.type) {
            case 2:
              switch (item.tab) {
                case 'info':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'projectTaskInfoTab', undefined);
                  break;
                case 'comments':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectTaskComment', undefined);
                  break;
                case 'messages':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectTaskMessage', undefined);
                  break;
                case 'files':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectTaskFile', undefined);
                  break;
                case 'meetings':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectTaskMeeting', undefined);
                  break;
                case 'crm':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectCrm', undefined);
                  break;
                case 'scm':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectScm', undefined);
                  break;
                case 'accountTHINK':
                  this.setToPointTask(item.companyId, item.projectId, item.id, 'projectTask', 'createProjectAccountTHINK', undefined);
                  break;
              }
              break;
            case 1:
              switch (item.tab) {
                case 'info':
                  this.setToPointProj(item.companyId, item.projectId, 'projectInfoTab');
                  break;
                case 'comments':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectComment');
                  break;
                case 'messages':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectMessage');
                  break;
                case 'files':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectFile');
                  break;
                case 'meetings':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectMeeting');
                  break;
                case 'crm':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectCrm');
                  break;
                case 'scm':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectScm');
                  break;
                case 'accountTHINK':
                  this.setToPointProj(item.companyId, item.projectId, 'createProjectAccountTHINK');
                  break;
              }
              break;
            case 3:
              switch (item.tab) {
                case 'info':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'businessUnitInfoTab');
                  break;
                case 'comments':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitComment');
                  break;
                case 'messages':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitMessage');
                  break;
                case 'files':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitFile');
                  break;
                case 'meetings':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitMeeting');
                  break;
                case 'crm':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitCrm');
                  break;
                case 'scm':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitScm');
                  break;
                case 'accountTHINK':
                  this.setToPointDep(item.companyId, item.businessUnitId, 'createBusinessUnitAccountTHINK');
                  break;
              }
              break;
            case 4:
              switch (item.tab) {
                case 'info':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'businessUnitTaskInfoTab', undefined);
                  break;
                case 'comments':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitTaskComment', undefined);
                  break;
                case 'messages':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitTaskMessage', undefined);
                  break;
                case 'files':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitTaskFile', undefined);
                  break;
                case 'meetings':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitTaskMeeting', undefined);
                  break;
                case 'crm':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitCrm', undefined);
                  break;
                case 'scm':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitScm', undefined);
                  break;
                case 'accountTHINK':
                  this.setToPointTask(item.companyId, item.businessUnitId, item.id, 'businessUnitTask', 'createBusinessUnitAccountTHINK', undefined);
                  break;
              }
              break;
            case 5:
              switch (item.tab) {
                case 'info':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'engagementInfoTab');
                  break;
                case 'comments':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementComment');
                  break;
                case 'messages':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementMessage');
                  break;
                case 'files':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementFile');
                  break;
                case 'meetings':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementMeeting');
                  break;
                case 'crm':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementCrm');
                  break;
                case 'scm':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementScm');
                  break;
                case 'accountTHINK':
                  this.setToPointEngagement(item.companyId, item.engagementId, 'createEngagementAccountTHINK');
                  break;
              }
              break;
            case 6:
              switch (item.tab) {
                case 'info':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'engagementTaskInfoTab', undefined);
                  break;
                case 'comments':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskComment', undefined);
                  break;
                case 'messages':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskMessage', undefined);
                  break;
                case 'files':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskFile', undefined);
                  break;
                case 'meetings':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskMeeting', undefined);
                  break;
                case 'crm':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskCrm', undefined);
                  break;
                case 'scm':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskScm', undefined);
                  break;
                case 'accountTHINK':
                  this.setToPointTask(item.companyId, item.engagementId, item.id, 'engagementTask', 'createEngagementTaskAccountTHINK', undefined);
                  break;
              }
              break;
          }
        } catch (err) {
          console.log(err)
        }
      },
      removeBookmarkOpenModal(bookmark) {
        this.$confirm(this.$t('project_removeBookmark'), this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          console.log('bookmark', bookmark)
          let url = ''
          switch(bookmark.type) {
            case 1:
              url = `/api/v1/bookmarks/setProject?companyId=${bookmark.companyId}&projectId=${bookmark.projectId}`
              break;
            case 2:
              url = `/api/v1/bookmarks/setProjectTask?companyId=${bookmark.companyId}&projectId=${bookmark.projectId}&projectTaskId=${bookmark.taskId}`
              break;
            case 3:
              url = `/api/v1/bookmarks/setBusinessUnit?companyId=${bookmark.companyId}&businessUnitId=${bookmark.businessUnitId}`
              break;
            case 4:
              url = `/api/v1/bookmarks/setBusinessUnitTask?companyId=${bookmark.companyId}&businessUnitId=${bookmark.businessUnitId}&businessUnitTaskId=${bookmark.taskId}`
              break;
            case 5:
              url = `/api/v1/bookmarks/setEngagement?companyId=${bookmark.companyId}&engagementId=${bookmark.engagementId}`
            break;
            case 6:
              url = `/api/v1/bookmarks/setEngagementTask?companyId=${bookmark.companyId}&engagementId=${bookmark.engagementId}&engagementTaskId=${bookmark.taskId}`
            break;
          }
          bookmark.bookmarks.info = false
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(url, bookmark.bookmarks)
              .then(response => {
                this.notification(this.$t('general_success'), this.$t('notification_bookmarkRemoved'), "success")
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
        }).catch(err => {
          console.log('err', err )
        })
      },
      openNoAccessModalBookmark(msg, bookmarkId){
        this.$confirm(msg, this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/bookmarks/deleteBookmarkNotif?bookmarkId=${bookmarkId}`)
              .then(response => {
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
        })
      },
      setToPointTimers() {

      },
      general(
          action,
          notificationId,
          companyid,
          companyName,
          email,
          hash,
          projectId,
          projectTaskId,
          projectTaskExpenseId,
          tempSharedProjectTaskId,
          fromUserName,
          taskName,
          params){
        // alert('hello')
        this.companyNameSelected = companyName
        this.ivitedNotificationId = notificationId
        this.invitedCompanyid = companyid
        this.invitedEmail = email
        this.invitedHash = hash
        this.tempSharedProjectTaskId = tempSharedProjectTaskId
        this.fromUserName = fromUserName
        this.taskName = taskName
        // console.log(invitedCompanyid, )
        console.log('action', action, 'notificationId', notificationId, 'companyId', companyid, 'email', email, 'hash', hash, 'projectId', projectId, 'projectTaskId', projectTaskId, 'tempSharedProjectTaskId', tempSharedProjectTaskId, 'fromUserName', fromUserName, 'taskName', taskName)
        if(action === "inviteCompanyUser"){
          this.$refs.openInviteConfirmation.open();
        }
        if(action === "deactivateCompanyUser" ||
          action === "activateCompanyUser" ||
          action === "approveProjectTaskExpense" ||
          action === "rejectProjectTaskExpense" ||
          action === "approveProjectTaskExpenseRequest" ||
          action === "rejectProjectTaskExpenseRequest" ||
          action === "approveProjectTaskCashAdvance" ||
          action === "rejectProjectTaskCashAdvance" ||
          action === "acceptShareProjectTask" ||
          action === "rejectShareProjectTask" ||
          action === "approveProjectTaskCashAdvanceRequest" ||
          action === "rejectProjectTaskCashAdvanceRequest" ||
          action === "receiveProjectTaskCashAdvance" ||
          action === "approveProjectTaskPurchaseRequest" ||
          action === "rejectProjectTaskPurchaseRequest" ||
          action === "Invitation rejected" ||
          action === "Invitation approved" ||
          action === 'rejectVendorInvoiceRequest' ||
          action === 'reccuringOverdue' ||
          action === 'businessUnitReccuringOverdue' ||
          action === 'engagementReccuringOverdue' ||
          action === 'businessUnitDeadLineOverdue' ||
          action === 'engagementDeadLineOverdue' ||
          action === 'approveVendorInvoiceRequest'){
          this.deleteNotification(notificationId, 'deleteGeneral')
        }
        if(action === 'submitProjectTaskExpense' ||
          action === 'submitProjectTaskExpenseRequest' ||
          action === 'submitEngagementExpense'){
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.openExpenseModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
                this.$refs.expenseInfoModal.activeNotificationId = notificationId
                resolve('ok')
                // this.$message({
                //   type: 'success',
                //   message: 'Open'
                // });
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          }else{
            this.openExpenseModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
            this.$refs.expenseInfoModal.activeNotificationId = notificationId
          }
        }

        if(action === 'submitProjectTaskCashAdvance' ||
          action === 'submitProjectTaskCashAdvanceRequest' ||
          action === 'depositProjectTaskCashAdvance' ){
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.openCashAdvanceModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
                this.$refs.cashAdvanceInfoModal.activeNotificationId = notificationId
                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          }else{
            this.openCashAdvanceModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
            this.$refs.cashAdvanceInfoModal.activeNotificationId = notificationId
          }
        }
        if(action === 'accountantApproveProjectTaskCashAdvanceRequest'){
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.openAccountedCashAdvanceModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
                this.$refs.accountedCashAdvanceInfoModal.activeNotificationId = notificationId
                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          }else{
            this.openAccountedCashAdvanceModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
            this.$refs.accountedCashAdvanceInfoModal.activeNotificationId = notificationId
          }
        }

        //Purchases
        if(action === 'createProjectTaskPurchaseRequest' || action === 'createProjectPurchaseRequest' || action === 'updateProjectTaskPurchaseRequest' || action === 'updateProjectPurchaseRequest'){
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.openPurchaseModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          }else{
            this.openPurchaseModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
          }
        }

        //Vendor Invoices
        if(action === 'createProjectTaskVendorInvoiceRequest' || action === 'createProjectVendorInvoiceRequest') {
            this.openRequestVendorInvoiceModal(companyid, projectId, projectTaskId, projectTaskExpenseId, action)
        }

        if(action === 'shareProjectTask'){
          this.$refs.openShareTaskConfirm.open();
        }

        // Create project
        if (action === 'createProject' || action === 'createBusinessUnit' || action === 'createEngagement') {
          if(companyid.toString() !== this.$route.query.companyId.toString() ){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.deleteNotification(notificationId, 'deleteGeneral');
                this.$store.dispatch('toggleActiveCompanyName', companyName);

                switch (action){
                  case 'createProject' :
                    this.$router.push({name: 'projects', query: { companyId: companyid, projectId: projectId, taskId: '0' }} );
                    if (this.$route.name === 'projects') {
                      this.rerenderMainLayout();
                    }
                    break;
                  case 'createBusinessUnit' :
                    this.$router.push({name: 'business-units', query: { companyId: companyid, businessUnitId: projectId, taskId: '0' }} );
                    if (this.$route.name === 'business-units') {
                      this.rerenderMainLayout();
                    }
                    break;
                  case 'createEngagement' :
                    this.$router.push({name: 'engagements', query: { companyId: companyid, engagementId: projectId, taskId: '0' }} );
                    if (this.$route.name === 'engagements') {
                      this.rerenderMainLayout();
                    }
                    break;
                }

                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel')
                });
              });
            })
          }else{
            this.deleteNotification(notificationId, 'deleteGeneral');

            switch (action){
              case 'createProject' :
                this.$router.push({name: 'projects', query: { companyId: companyid, projectId: projectId, taskId: '0' }} );
                if (this.$route.name === 'projects') {
                  this.rerenderMainLayout();
                }
                break;
              case 'createBusinessUnit' :
                this.$router.push({name: 'business-units', query: { companyId: companyid, businessUnitId: projectId, taskId: '0' }} );
                if (this.$route.name === 'business-units') {
                  this.rerenderMainLayout();
                }
                break;
              case 'createEngagement' :
                this.$router.push({name: 'engagements', query: { companyId: companyid, engagementId: projectId, taskId: '0' }} );
                if (this.$route.name === 'engagements') {
                  this.rerenderMainLayout();
                }
                break;
            }
          }
        }
        // reccuring Overdue BU/ENG only
        if (action === 'reccuringOverdue' ||
            action === 'engagementReccuringOverdue' ||
            action === 'businessUnitDeadLineOverdue' ||
            action === 'engagementDeadLineOverdue' ||
            action === 'businessUnitReccuringOverdue') {
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.$store.dispatch('toggleActiveCompanyName', companyName);
                switch (action) {
                  case 'reccuringOverdue':
                  case 'businessUnitReccuringOverdue':
                  case 'businessUnitDeadLineOverdue':
                    this.setToPointTask(companyid, projectId, projectTaskId, 'businessUnitTask')
                    break;
                  case 'engagementReccuringOverdue':
                  case 'engagementDeadLineOverdue':
                    this.setToPointTask(companyid, projectId, projectTaskId, 'engagementTask')
                    break;
                }
                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          }else{
            switch (action) {
              case 'reccuringOverdue':
              case 'businessUnitReccuringOverdue':
              case 'businessUnitDeadLineOverdue':
                this.setToPointTask(companyid, projectId, projectTaskId, 'businessUnitTask')
                break;
              case 'engagementReccuringOverdue':
              case 'engagementDeadLineOverdue':
                this.setToPointTask(companyid, projectId, projectTaskId, 'engagementTask')
                break;
            }
          }
        }

        if (action === 'forAnAccountant') {
          if(companyid.toString() !== this.$route.query.companyId.toString()){
            return new Promise ((resolve, reject) => {
              this.$confirm(`${this.$t('modal_notifications_notificationFromAnotherCompany')}<br> ${companyName}`,{
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('general_open'),
                cancelButtonText: this.$t('general_cancel'),
                type: 'info'
              }).then(() => {
                this.deleteNotification(notificationId, 'deleteGeneral')
                this.$store.dispatch('toggleActiveCompanyName', companyName)
                this.$router.push(params.link).then(res => {
                  this.rerenderMainLayout()
                })
                resolve('ok')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('general_cancel'),
                });
              });
            })
          } else {
            console.log(params, this.$route)
            this.deleteNotification(notificationId, 'deleteGeneral')
            this.$router.push(params.link).then(res => {
              this.rerenderMainLayout()
            })
          }
        }
      },
      rejectNotification(notificationId, noti){
        this.$refs.openInviteConfirmation.close();
        this.deleteRejectNotification(notificationId, noti)
      },
      rejectNotificationSharing(notificationId, noti){
        this.$refs.nestedChildSharing.close();
        this.$refs.openShareTaskConfirm.close();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/sharedProjectTasks/reject?companyId=${this.invitedCompanyid}&tempSharedProjectTaskId=${this.tempSharedProjectTaskId}`)
          .then(response => {
            if(response.data.success) {
              this.notification(this.$t('general_success'), this.$t('general_reject'), "success");
              this.deleteNotification(notificationId, noti)
            }
          }).catch(error => {
            this.deleteNotification(this.ivitedNotificationId, 'deleteGeneral');
            console.log('error', error)
        })
      },
      acceptNotification(){
        this.$refs.openInviteConfirmation.close();
        let loader = this.$loading.show();
        axios
          .post('/api/v1/companyUsers/confirmUserInvite', {
            companyId: this.invitedCompanyid,
            email: this.invitedEmail,
            hash: this.invitedHash
          })
          .then(response => {
            if(response.data.success) {
              this.notification(this.$t('general_success'), this.$t('modal_notifications_successfullyInvited'), "success");
              // localStorage.setItem('token', response.data.token)
              sessionStorage.setItem('token', response.data.token);
              this.$store.dispatch('loadUser')
              // this.deleteNotification(this.ivitedNotificationId, 'deleteGeneral')
            }
            loader.hide()
          })
          .catch(error => {
            if(error.response.data.message === 'ivite_not_exist'){
              // alert("hello")
              this.deleteNotification(this.ivitedNotificationId, 'deleteGeneral')
            }
            console.log('An error occurred:', error.response.data.message);
            loader.hide()
          })
      },
      acceptNotificationSharing(){
        this.$refs.openShareTaskConfirm.close();
        let loader = this.$loading.show();
        axios.post(`/api/v1/sharedProjectTasks/accept?companyId=${this.invitedCompanyid}&tempSharedProjectTaskId=${this.tempSharedProjectTaskId}`)
          .then(response => {
            if(response.data.success) {
              this.notification(this.$t('general_success'), this.$t('modal_notifications_successfullyShared'), "success");
              this.deleteNotification(this.ivitedNotificationId, 'deleteGeneral');
              if(this.$route.name === 'shared-projects'){
                this.$emit('setSharedTask')
              }
              if(this.$route.name === 'projects'){
                this.$emit('refreshShared')
              }
              this.$store.dispatch('getMenuStatistics')
            }
            loader.hide()
          })
          .catch(error => {
            this.deleteNotification(this.ivitedNotificationId, 'deleteGeneral')
            console.log('An error occurred:', error.response.data.message);
            loader.hide()
          })
      },
      async meetingEventClick (event) {
        try {
          console.log('ssss', event)
          let noti = ''
          let route = ''
          switch (event.meetingType) {
            case 1:
              noti = 'createProjectMeetings'
              route = 'projects'
              break;
            case 4:
              noti = 'createProjectTaskMeetings'
              route = 'projects'
              break;
            case 2:
              noti = 'createBusinessUnitMeeting'
              route = 'business-units'
              break;
            case 5:
              noti = 'createBusinessUnitTaskMeeting'
              route = 'business-units'
              break;
            case 3:
              noti = 'createEngagementMeeting'
              route = 'engagements'
              break;
            case 6:
              noti = 'createEngagementTaskMeeting'
              route = 'engagements'
              break;
          }
          console.log('EVENT', event)
          this.checkIfCompanySelected(event.companyId,
                                      event.parentId,
                                      event.taskId,
                                      event.id,
                                      event.companyName,
                                      null,
                                      noti,
                                      route,
                                      5)
        } catch (err) {
          console.log(err)
        }
      },
      openExpenseModal(companyId, projectId, projectTaskId, projectTaskExpenseId, action){
        let state = '';
        if(action === 'submitProjectTaskExpense'){
          state = 'projectTaskExpenses'
        }else if(action === 'submitEngagementExpense'){
          state = 'engagementTaskExpenses'
        }else if(action === 'submitBusinessUnitExpense'){
          state = 'businessUnitTaskExpenses'
        }else if(action === 'submitProjectTaskExpenseRequest'){
          state = 'requestProjectTaskExpenses'
        }
        console.log('mylog', companyId, projectId, projectTaskId, projectTaskExpenseId, state)
        this.$refs.expenseInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      openCashAdvanceModal(companyId, projectId, projectTaskId, projectTaskExpenseId, action){
        console.log('companyId, projectId, projectTaskId, projectTaskExpenseId, action', companyId, projectId, projectTaskId, projectTaskExpenseId, action)
        let state = '';
        if(action === 'submitProjectTaskCashAdvance'){
          state = 'projectTasksCashAdvance'
        }else if(action === 'submitEngagementTaskCashAdvance'){
          state = 'engagementTasksCashAdvance'
        }else if(action === 'submitBusinessUnitTaskCashAdvance'){
          state = 'businessUnitTasksCashAdvance'
        }else if(action === 'submitProjectTaskCashAdvanceRequest'){
          state = 'requestProjectTasksCashAdvance'
        }else if(action === 'submitEngagementTaskCashAdvanceRequest'){
          state = 'requestEngagementTasksCashAdvance'
        }else if(action === 'submitBusinessUnitTaskCashAdvanceRequest'){
          state = 'requestBusinessUnitTasksCashAdvance'
        }else if(action === 'depositProjectTaskCashAdvance'){
          state = 'projectTasksCashAdvance'
        }
        this.$refs.cashAdvanceInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      openAccountedCashAdvanceModal(companyId, projectId, projectTaskId, projectTaskExpenseId, action){
        let state = '';
        if(action === 'accountantApproveProjectTaskCashAdvanceRequest'){
          state = 'projectTasksCashAdvance'
        }else if(action === 'accountantApproveEngagementTaskCashAdvanceRequest'){
          state = 'engagementTasksCashAdvance'
        }else if(action === 'accountantApproveBusinessUnitTaskCashAdvanceRequest'){
          state = 'businessUnitTasksCashAdvance'
        }
        this.$refs.accountedCashAdvanceInfoModal.openModalInfo(companyId, projectId, projectTaskId, projectTaskExpenseId, state);
      },
      openPurchaseModal(companyId, projectId, projectTaskId, projectTaskExpenseId, action){
        console.log('companyId, projectId, projectTaskId, projectTaskExpenseId, action', companyId, projectId, projectTaskId, projectTaskExpenseId, action)
        let state = '';
        if(action === 'createProjectTaskPurchaseRequest' || action === 'createProjectPurchaseRequest' || action === 'updateProjectTaskPurchaseRequest' || action === 'updateProjectPurchaseRequest'){
          state = 'project'
        }else if(action === 'submitBusinessUnitTaskCashAdvance'){
          state = 'businessUnitTasksCashAdvance'
        }else if(action === 'submitProjectTaskCashAdvanceRequest'){
          state = 'requestProjectTasksCashAdvance'
        }else if(action === 'submitEngagementTaskCashAdvanceRequest'){
          state = 'requestEngagementTasksCashAdvance'
        }else if(action === 'submitBusinessUnitTaskCashAdvanceRequest'){
          state = 'requestBusinessUnitTasksCashAdvance'
        }else if(action === 'depositProjectTaskCashAdvance'){
          state = 'projectTasksCashAdvance'
        }
        this.$refs.purchaseRequest.openModalEditManager(companyId, projectId, projectTaskId, projectTaskExpenseId, state, 'manager');
      },
      openRequestVendorInvoiceModal(companyId, projectId, projectTaskId, vendorInvoiceId, state){
        let myState = '';
        if (state === 'createProjectVendorInvoiceRequest' || state === 'createProjectTaskVendorInvoiceRequest') myState = 'project';
        this.$refs.vendorInvoiceRequest.openModalInfo(companyId, projectId, projectTaskId,  vendorInvoiceId, myState, 'manager');
      },
      // handleClick(id, page){
      //   return new Promise ((resolve, reject) => {
      //     this.notificationId = id
      //     if(id === 10){
      //       this.$refs.chat2.openChat();
      //       return
      //     }
      //
      //     if(id === 7){
      //       this.getBookmarkList();
      //       return
      //     }
      //
      //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //     axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //     axios
      //       .post(`/api/v1/notifications/list?type=${id}&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}&page=${page || 1}&filterBy=null`)
      //       .then(response => {
      //         console.log('---', response.data);
      //         if(id === 1){
      //           this.generalNotifications = page ? this.generalNotifications.concat(response.data.newList) : response.data.newList
      //         }else if(id === 2){
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.taskProgressNotifications = page ? this.taskProgressNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.taskProgressNotificationsList = this.filterNotifications(this.taskProgressNotifications, this.activeNotiTab);
      //           } else {
      //             this.taskProgressNotificationsList = page ? this.taskProgressNotificationsList.concat(response.data.newList) : response.data.newList;
      //           }
      //         }else if(id === 4){
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.commentNotifications = page ? this.commentNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.commentNotificationsList = this.filterNotifications(this.commentNotifications, this.activeNotiTab);
      //           } else {
      //             this.commentNotificationsList = page ? this.commentNotificationsList.concat(response.data.newList) : response.data.newList
      //           }
      //         }else if(id === 3) {
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.messageNotifications = page ? this.messageNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.messageNotificationsList = this.filterNotifications(this.messageNotifications, this.activeNotiTab);
      //           } else {
      //             this.messageNotificationsList = page ? this.messageNotificationsList.concat(response.data.newList) : response.data.newList;
      //           }
      //         }else if(id === 5){
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.meetingsNotifications = page ? this.meetingsNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.meetingsNotificationsList = this.filterNotifications(this.meetingsNotifications, this.activeNotiTab);
      //           } else {
      //             this.meetingsNotificationsList = page ? this.meetingsNotificationsList.concat(response.data.newList) : response.data.newList;
      //           }
      //         }else if(id === 6){
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.reminderNotifications = page ? this.reminderNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.reminderNotificationsList = this.filterNotifications(this.reminderNotifications, this.activeNotiTab);
      //           } else {
      //             this.reminderNotificationsList = page ? this.reminderNotificationsList.concat(response.data.newList) : response.data.newList;
      //           }
      //         }else if(id === 8){
      //           this.activeNotiTab = page ? this.activeNotiTab : '0';
      //           this.documentNotifications = page ? this.documentNotifications.concat(response.data.newList) : response.data.newList;
      //           if (this.activeNotiTab !== '0') {
      //             this.documentNotificationsList = this.filterNotifications(this.documentNotifications, this.activeNotiTab);
      //           } else {
      //             this.documentNotificationsList = page ? this.documentNotificationsList.concat(response.data.newList) : response.data.newList;
      //           }
      //         }else if(id === 9){
      //           this.activeNotiTab = '0';
      //           this.financeNotifications = page ? this.financeNotifications.concat(response.data.list) : response.data.list
      //         }
      //
      //         this.nextPage = response.data.nextPage
      //         resolve('success')
      //       })
      //       .catch(error => {
      //         console.log('An error occurred:', error);
      //         reject(error.message)
      //       });
      //   })
      // },
      loadNotifications(notificationId, page, filterBy) {
        console.log('notificationId, page, filterBy', notificationId, page, filterBy);
        // for first time hover
        this.notificationId = notificationId;

        if(notificationId === 10){
          this.$refs.chat2.openChat();
          return
        }

        if(notificationId === 7){
          this.getBookmarkList();
          return
        }

        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/notifications/list?type=${notificationId}&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}&page=${page || 1}&filterBy=${filterBy || null}`)
            .then(response => {
              console.log('---', response.data);
              switch (notificationId){
                case 1:
                  this.generalNotifications = page === 1 ? response.data.newList : this.generalNotifications.concat(response.data.newList);
                  break;
                case 9:
                  this.financeNotifications = page === 1 ? response.data.list : this.financeNotifications.concat(response.data.list);
                  break;
                case 2:
                  this.taskProgressNotifications = page === 1 ? response.data.newList : this.taskProgressNotifications.concat(response.data.newList);
                  break;
                case 4:
                  this.commentNotifications = page  === 1 ? response.data.newList : this.commentNotifications.concat(response.data.newList);
                  break;
                case 3:
                  this.messageNotifications = page === 1 ? response.data.newList : this.messageNotifications.concat(response.data.newList);
                  break;
                // case 5:
                //   this.meetingsNotifications = page === 1 ? response.data.newList : this.meetingsNotifications.concat(response.data.newList);
                //   break;
                case 6:
                  this.reminderNotifications = page === 1 ? response.data.newList : this.reminderNotifications.concat(response.data.newList);
                  break;
                case 8:
                  this.documentNotifications = page === 1 ? response.data.newList : this.documentNotifications.concat(response.data.newList);
                  break;
              }
              this.nextPage = response.data.nextPage;
              resolve(response.data.newList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error.message)
            });
        })
      },
      loadMeetingNotifications(filterBy){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/notifications/list?type=5&timeZone=${Intl.DateTimeFormat().resolvedOptions().timeZone}&page=1&filterBy=${filterBy}`)
            .then(response => {
              const sortedArray = response.data.list.sort(this.compare)
              console.log('sortedArray', sortedArray)
              const arrayOfStarts = [...new Set(sortedArray.map(val => moment(val.params._timeStartMeeting.toString(), 'X').format("ddd DD MMM 'YY")))]
              console.log('____', arrayOfStarts)
              let result = []
              for (let i = 0; i < arrayOfStarts.length; i++) {
                const myObj = {
                  dateCheck: arrayOfStarts[i],
                  arrayDate: sortedArray.filter(val => moment(val.params._timeStartMeeting.toString(), 'X').format("ddd DD MMM 'YY") ===  arrayOfStarts[i])
                }
                result.push(myObj)
              }
              this.meetingsNotifications = result
            })
            .catch(error => {
              console.log('error', error)
            })
      },
      compare( a, b ) {
        if ( a.params._timeStartMeeting < b.params._timeStartMeeting ){
          return 1;
        }
        if ( a.params._timeStartMeeting > b.params._timeStartMeeting){
          return -1;
        }
        return 0;
      },
      getBookmarkList(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/bookmarks/myList?companyId=${this.$route.query.companyId}`)
          .then(response => {
            console.log('deleted notification', response.data);
            this.activeNotiTab = '0'
            // let myList =  response.data.myList
            let myBookMarkList = []
            for(let i = 0; i < response.data.myList.length; i++) {
              console.log('response.data.myList[i].bookmarks', response.data.myList[i].bookmarks)
              for (const key in response.data.myList[i].bookmarks) {
                if (response.data.myList[i].bookmarks.hasOwnProperty(key)) {
                  console.log(key + " -> " + response.data.myList[i].bookmarks[key]);
                  if(response.data.myList[i].bookmarks[key]){
                    let bookmark = {}
                    switch (response.data.myList[i].type) {
                      case 1:
                        bookmark.projectId = response.data.myList[i].projectId
                        bookmark.name = response.data.myList[i].projectName
                        break;
                      case 2:
                        bookmark.name = response.data.myList[i].projectTaskName
                        bookmark.projectId = response.data.myList[i].projectId
                        bookmark.id = response.data.myList[i].projectTaskId
                        break;
                      case 3:
                        bookmark.name = response.data.myList[i].businessUnitName
                        bookmark.businessUnitId = response.data.myList[i].businessUnitId
                        break;
                      case 4:
                        bookmark.name = response.data.myList[i].businessUnitTaskName
                        bookmark.businessUnitId = response.data.myList[i].businessUnitId
                        bookmark.id = response.data.myList[i].businessUnitTaskId
                        break;
                      case 5:
                        bookmark.name = response.data.myList[i].engagementName
                        bookmark.engagementId = response.data.myList[i].engagementId
                        break;
                      case 6:
                        bookmark.name = response.data.myList[i].engagementTaskName
                        bookmark.engagementId = response.data.myList[i].engagementId
                        bookmark.id = response.data.myList[i].engagementTaskId
                        break;
                    }
                    bookmark.type = response.data.myList[i].type
                    bookmark.companyName = response.data.myList[i].companyName
                    bookmark.companyId = response.data.myList[i].companyId
                    bookmark.tab = key
                    bookmark.bookmarkId = response.data.myList[i].bookmarkId
                    bookmark.bookmarks = response.data.myList[i].bookmarks
                    bookmark.taskId = response.data.myList[i].projectTaskId ? response.data.myList[i].projectTaskId : response.data.myList[i].businessUnitTaskId ? response.data.myList[i].businessUnitTaskId : response.data.myList[i].engagementTaskId ? response.data.myList[i].engagementTaskId : null
                    myBookMarkList.push(bookmark)
                  }
                }
              }
            }
            this.bookmarkNotifications = myBookMarkList
            this.bookmarkNotificationsList = myBookMarkList
            console.log('MY OWN LIST', myBookMarkList)
            // if (response.data.success) {
            // }
          })
          .catch(error => {
            // alert('goodbue')
          });
      },
      // testing(){
      //   // alert('hello')
      //   // this.$socket.open()
      //   this.$emit('openDialog')
      // },
      toggleFullscreen() {
        var element = document.body;
        var isFullscreen = document.webkitIsFullScreen || document.mozFullScreen || false;
        element.requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || function () { return false; };
        document.cancelFullScreen = document.cancelFullScreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || function () { return false; };
        isFullscreen ? document.cancelFullScreen() : element.requestFullScreen();
        this.fullscreen = !isFullscreen
      },
      //TODO
      setShared(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route){
        console.log('mnmnmnmnmnmnmn', companyId, projectId, taskId, stateId, companyName, notificationId, noti, route)
        this.$store.dispatch('getCompanyLayout', companyId).then(response => {
          let data = {
            companyId: companyId,
            companyUserId: response.companyUserId
          };
          this.$socket.emit('companyChanged', data);
          this.$store.dispatch('companyChange', companyId);
          this.$store.dispatch('getMenuStatistics', companyId)
        });

          if(this.$route.name !== 'projects' && route === 'projects'){
            this.$store.dispatch('projectChange', projectId);
            this.$router.push(`/projects?companyId=${companyId}&projectId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewProjectTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}` + `&stateId=${stateId}` )
          }else if (this.$route.name === 'projects' && route === 'projects'){
            this.$store.dispatch('projectChange', projectId);
            this.$router.push(`/projects?companyId=${companyId}&projectId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewProjectTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}` + `&stateId=${stateId}`).then(res => {
                this.rerenderMainLayout()
            })
          }

          if(this.$route.name !== 'business-units' && route === 'business-units'){
            this.$router.push(`/business-units/?companyId=${companyId}&businessUnitId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewBusinessUnitTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}`)
          }else if(this.$route.name === 'business-units' && route === 'business-units'){
            this.$router.push(`/business-units/?companyId=${companyId}&businessUnitId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewBusinessUnitTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}`).then(res => {
                this.rerenderMainLayout()
            })
          }

          if(this.$route.name !== 'engagements' && route === 'engagements'){
            this.$router.push(`/engagements/?companyId=${companyId}&engagementId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewEngagementTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}`)
          }else if(this.$route.name === 'engagements' && route === 'engagements'){
            this.$router.push(`/engagements/?companyId=${companyId}&engagementId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewEngagementTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}`).then(res => {
                this.rerenderMainLayout()
            })
          }

          if(this.$route.name !== 'shared-projects' && route === 'shared-projects'){
            // CANT DO NOW BECAUSE USER IN SHARED TEAM!
            // this.$store.dispatch('projectChange', projectId);
            this.$router.push(`/shared-projects?companyId=${companyId}&projectId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewProjectTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}` )
          }else if (this.$route.name === 'shared-projects' && route === 'shared-projects'){
            // CANT DO NOW BECAUSE USER IN SHARED TEAM!
            // this.$store.dispatch('projectChange', projectId);
            this.$router.push(`/shared-projects?companyId=${companyId}&projectId=${projectId}&taskId=${taskId || 0}&tabName=${noti}` + `${noti === 'reviewProjectTaskDocument' ? `&activeDocumentTab=${stateId}` : ''}`).then(res => {
            this.rerenderMainLayout()
            })
          }

        // this.deleteNotification(notificationId, noti);
        if(noti === 'reviewProjectTaskDocument' || noti === 'reviewBusinessUnitTaskDocument' || noti === 'reviewEngagementTaskDocument' ){
          return
        }else{
          this.deleteNotification(notificationId, noti)
        }
      },
      deleteNotification(notificationId, noti){
        if(notificationId){
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          // TODO axios.post(`/api/v1/notifications/delete?notificationId=${notificationId}`);
          axios.post(`/api/v1/notifications/show?notificationId=${notificationId}`)
            .then(response => {
              console.log('deleted notification', response.data);
              loader.hide();
              if (response.data.success) {
                if(noti === 'deleteGeneral'){
                  this.loadNotifications(1, 1, 'null')
                }
              }
            })
            .catch(error => {
              loader.hide();
            });
        }else{
          return
        }
      },
      removeNotification(notificationId, noti){
        if(notificationId){
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/notifications/delete?notificationId=${notificationId}`)
          // axios.post(`/api/v1/notifications/show?notificationId=${notificationId}`)
            .then(response => {
              console.log('deleted notification', response.data);
              loader.hide();
              if (response.data.success) {
                if(noti === 'deleteGeneral'){
                  this.loadNotifications(1, 1, 'null')
                }
                // if(noti === 'createProjectComment' || noti === 'createProjectTaskComment'){
                //   this.user.notifications.commentNotificationCount = this.user.notifications.commentNotificationCount - 1
                // }else if(noti === 'deleteGeneral'){
                //   this.notification("Success", "Successfully", "success")
                //   this.user.notifications.generalNotificationCount = this.user.notifications.generalNotificationCount - 1
                // }else{
                //   this.user.notifications.taskProgressNotificationCount = this.user.notifications.taskProgressNotificationCount - 1
                // }
                // alert("hello")
              }
            })
            .catch(error => {
              loader.hide();
              // alert('goodbue')
            });
        }else{
          return
        }
      },
      async handleClickNotiTab(tab, event){
        try {
          switch (this.notificationId){
            case 1:
              this.generalNotifications = [];
              break;
            case 9:
              this.financeNotifications = [];
              break;
            case 2:
              this.taskProgressNotifications = [];
              break;
            case 4:
              this.commentNotifications = [];
              break;
            case 3:
              this.messageNotifications = [];
              break;
            // case 5:
            //   this.meetingsNotifications = [];
            //   break;
            case 6:
              this.reminderNotifications = [];
              break;
            case 8:
              this.documentNotifications = [];
              break;
          }
          await this.loadNotifications(this.notificationId, 1, tab.name);
        } catch (err) {
          console.log(err)
        }
      },
      handleClickMeetingNotiTab(tab){
        this.loadMeetingNotifications(tab.name)
      },
      async infiniteHandler($state){
        try {
          console.log('$state', $state);
          console.log('this.notificationId, this.nextPage, this.activeNotiTab', this.notificationId, this.nextPage, this.activeNotiTab);
          if (this.notificationId && this.nextPage) {
            await this.loadNotifications(this.notificationId, this.nextPage, this.activeNotiTab);
            $state.loaded();
          }else {
            $state.complete();
          }
        } catch (err) {
          console.log(err)
        }
      },
      deleteRejectNotification(notificationId, noti){
        if(notificationId){
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/companyUsers/rejectInvite?notificationId=${notificationId}`)
            .then(response => {
              console.log('deleted notification', response.data);
              if (response.data.success) {
                if(noti === 'deleteGeneral'){
                  this.loadNotifications(1, 1, 'null')
                }
              }
            })
            .catch(error => {
              // alert('goodbue')
            });
        }else{
          return
        }
      },
      openMeetingCalendar () {
        this.$refs.meetingCalendar.openModal()
      },
      asRead(type) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios.get(`/api/v1/notifications/deleteByType?notificationType=${type}`)
        axios.get(`/api/v1/notifications/readAll?type=${type}`)
          .then(response => {
            loader.hide();
            console.log('deleted notifications', response.data);
            if (response.data.success) {
              if(type === 2){
                this.user.notifications.taskProgressNotificationCount = 0
              }else if(type === 4){
                this.user.notifications.commentNotificationCount = 0
              }else if(type === 5){
                this.user.notifications.meetingNotificationCount = 0
              }else if(type === 6){
                this.user.notifications.reminderNotificationCount = 0
              }
              this.notificationId = type;
              this.nextPage = null;
              this.loadNotifications(type, 1, 'null')
            }
          })
          .catch(error => {
            loader.hide();
          });
      },
      async checkIfCompanySelected(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route, notificationType){
        console.log('companyId', companyId, 'projectId', projectId, 'takId', taskId, 'stateId', stateId, 'companyName', companyName, 'notificationId', notificationId, 'noti', noti, 'route', route, 'notificationType', notificationType)
        try {
          const userAccess = await this.checkUserAccess(companyId, projectId, taskId, route, noti, notificationType, notificationId, stateId)
          // CHECK IF USER IN SHARED TEAM OR IN TEAM
          const data = await this.checkIfTaskShared(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route);
          switch (this.$route.query.companyId.toString()) {
            // if notification from current company
            case data.companyId.toString() :
              switch (data.route) {
                case 'projects':
                  // if project notification
                  if (!data.taskId) {
                    this.setToPointProj(data.companyId, data.parentId, data.noti);
                    switch (data.noti) {
                      case 'createProjectComment':
                      case 'customReminderProjectMeeting':
                      case 'createProjectMeetings':
                        this.$store.dispatch('setStateId', data.stateId);
                        break;
                    }
                  } else if (this.$route.query.projectId && this.$route.query.projectId.toString() !== data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setToPointTask(data.companyId, data.parentId, data.taskId, 'projectTask', data.noti, data.stateId)
                  } else if (this.$route.query.projectId && this.$route.query.projectId.toString() === data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.selectCreatedTaskInSameParent(data.taskId, data.noti, data.stateId);
                  } else if (!this.$route.query.projectId && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route);
                  }

                  if (data.noti !== "reviewProjectTaskDocument") this.deleteNotification(data.notificationId, 'deleteGeneral');
                  break;
                case 'business-units':
                  // check if notification from current bu
                  if (!data.taskId) {
                    this.setToPointDep(data.companyId, data.parentId, data.noti);
                    switch (data.noti) {
                      case 'createBusinessUnitComment':
                      case 'createBusinessUnitMeeting':
                        this.$store.dispatch('setStateId', data.stateId);
                        break;
                    }
                  } else if (this.$route.query.businessUnitId && this.$route.query.businessUnitId.toString() !== data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setToPointTask(data.companyId, data.parentId, data.taskId, 'businessUnitTask', data.noti, data.stateId)
                  } else if (this.$route.query.businessUnitId && this.$route.query.businessUnitId.toString() === data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.selectCreatedTaskInSameParent(data.taskId, data.noti, data.stateId);
                  } else if (!this.$route.query.businessUnitId && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route);
                  }
                  if (data.noti !== "reviewBusinessUnitTaskDocument") this.deleteNotification(data.notificationId, 'deleteGeneral');
                  break;
                case 'engagements':
                  // check if notification from current eng
                  if (!data.taskId) {
                    this.setToPointEngagement(data.companyId, data.parentId, data.noti);
                    switch (data.noti) {
                      case 'createEngagementComment':
                      case 'createEngagementMeeting':
                        this.$store.dispatch('setStateId', data.stateId);
                        break;
                    }
                  } else if (this.$route.query.engagementId && this.$route.query.engagementId.toString() !== data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setToPointTask(data.companyId, data.parentId, data.taskId, 'engagementTask', data.noti, data.stateId)
                  } else if (this.$route.query.engagementId && this.$route.query.engagementId.toString() === data.parentId.toString() && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.selectCreatedTaskInSameParent(data.taskId, data.noti, data.stateId);
                  } else if (!this.$route.query.engagementId && data.taskId) {
                    // set active state to store
                    this.$store.dispatch('setStateId', data.stateId);
                    this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route);
                  }
                  if (data.noti !== "reviewEngagementTaskDocument") this.deleteNotification(data.notificationId, 'deleteGeneral');
                  break;

              }
              break;
            default:
              this.$confirm(`Change company to ${data.companyName}. Continue?`, {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'info'
              }).then(() => {
                // set active state to store
                this.$store.dispatch('setStateId', data.stateId);
                this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route);
                this.$store.dispatch('toggleActiveCompanyName', data.companyName);
                this.$refs.chat2.closeAll();
                // this.$emit('closeChat2')
                this.$message({
                  type: 'success',
                  message: 'Company Changed'
                });
                // close chat if it open
                if(this.$refs.chat2.list) {
                  this.$refs.chat2.list = false
                }
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Cancel'
                });
              });
              break;
          }
          // if (data.companyId.toString() !== this.$route.query.companyId.toString()) {
          //     this.$confirm(`Change company to ${data.companyName}. Continue?`, {
          //       confirmButtonText: 'OK',
          //       cancelButtonText: 'Cancel',
          //       type: 'info'
          //     }).then(() => {
          //       this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route);
          //       this.$store.dispatch('toggleActiveCompanyName', data.companyName);
          //       this.$refs.chat2.closeAll();
          //       // this.$emit('closeChat2')
          //       this.$message({
          //         type: 'success',
          //         message: 'Company Changed'
          //       });
          //       // close chat if it open
          //       if(this.$refs.chat2.list) {
          //         this.$refs.chat2.list = false
          //       }
          //     }).catch(() => {
          //       this.$message({
          //         type: 'info',
          //         message: 'Cancel'
          //       });
          //     });
          // } else {
          //   this.setShared(data.companyId, data.parentId, data.taskId, data.stateId, data.companyName, data.notificationId, data.noti, data.route)
          // }
        } catch (err) {
          console.log('err +++++++++++++=', err)
        }
      },
      checkUserAccess(companyId, parentId, taskId, route, noti, notificationType, notificationId, stateId) {
        return new Promise((resolve, reject) => {
          let typeId = false
          switch (route){
            case 'projects':
              typeId = taskId ? 4 : 1
              break;
            case 'business-units':
              typeId = taskId ? 5 : 2
              break;
            case 'engagements':
              typeId = taskId ? 6 : 3
              break;
          }
          let notiTypeId = notificationType
          switch(noti){
            case 'setShared':
              notiTypeId = 2
              break;
          }

          // костыль
          if (notificationType === 6)  notiTypeId = 5
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .post(`/api/v1/checkUsersAccess/check?companyId=${companyId}&parentId=${parentId}&taskId=${taskId || null}&typeId=${typeId}&action=${notiTypeId}&stateId=${stateId || null}`)
              .then(response => {
                loader.hide()
                // костыль для букмарков
                if (noti === 'bookmark'){
                  return resolve(response.data.checkUserObj)
                }
                console.log('checkUserReponse', response.data.checkUserObj)
                switch (typeId) {
                  case 1:
                  case 2:
                  case 3:
                    // project
                    if (!response.data.checkUserObj.notDeleted) return this.openNoAccessModal(
                        typeId === 1 ? this.$t('notification_checkUser_projectWasDeletedDeleteThisNotification')
                        : typeId === 2 ? this.$t('notification_checkUser_businessUnitWasDeletedDeleteThisNotification')
                        : this.$t('notification_checkUser_engagementWasDeletedDeleteThisNotification') , notificationId)
                    if (!response.data.checkUserObj.hasAccessParent) return this.openNoAccessModal(
                        typeId === 1 ? this.$t('notification_youAreNotPartOfThisProjectteamDeleteThisNotification')
                        : typeId === 2 ? this.$t('notification_youAreNotPartOfThisBusinessUnitteamDeleteThisNotification')
                        : this.$t('notification_youAreNotPartOfThisEngagementTeamDeleteThisNotification'), notificationId)
                    if (!response.data.checkUserObj.hasPermissions) return this.openNoAccessModal(this.$t('notification_youDoNotHavePermissionsToGetAccessToThisTabDeleteThisNotification'), notificationId)
                    if (!response.data.checkUserObj.isExist && notiTypeId === 5) return this.openNoAccessModal(this.$t('notification_meetingWasRemoved'), notificationId)
                    break;
                  case 4:
                  case 5:
                  case 6:
                    // tasks
                    if (!response.data.checkUserObj.notDeleted) return this.openNoAccessModal(this.$t('notification_taskRemovedDeleteThisNotification'), notificationId)
                    if (!response.data.checkUserObj.hasAccessTask) return this.openNoAccessModal(this.$t('notification_youNotPresentInTheTaskTeamDeleteThisNotification'), notificationId)
                    if (!response.data.checkUserObj.hasPermissions) return this.openNoAccessModal(this.$t('notification_youDoNotHavePermissionsToGetAccessToThisTabDeleteThisNotification'), notificationId)
                    if (!response.data.checkUserObj.isExist && notiTypeId === 2) return this.openNoAccessModal(this.$t('notification_progressNodeWasRemoved'), notificationId)
                    if (!response.data.checkUserObj.isExist && notiTypeId === 5) return this.openNoAccessModal(this.$t('notification_meetingWasRemoved'), notificationId)
                    break;
                }
                resolve(response.data)
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
                reject('error')
              });
        })
      },
      clickDocument(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route, notificationType, params) {
        console.log('companyId', companyId, 'parentId', projectId, 'taskId', taskId, 'stateId', stateId, 'companyName', companyName, 'notificationId', notificationId, 'noti', noti, 'route', route, 'notificationType', notificationType)
        switch (noti) {
          case 'acceptEngagementTaskDocument':
          case 'acceptBusinessUnitTaskDocument':
          case 'acceptProjectTaskDocument':
          case 'rejectEngagementTaskDocument':
          case 'rejectBusinessUnitTaskDocument':
          case 'rejectProjectTaskDocument':
            this.openDocumentModal(params)
            this.deleteNotification(notificationId, 'deleteGeneral');
            break;
          default:
            this.checkIfCompanySelected(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route, notificationType)
        }
      },
      openDocumentModal(params) {
        console.log('params', params)
        this.$refs.headerDocumentModal.openModal(params)
      },
      openNoAccessModal(msg, notificationId){
        this.$confirm(msg, this.$t('notification_title_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.removeNotification(notificationId)
        })
      },
      async openModalConfirmMeeting(companyId, projectId, taskId, meetingId, companyName, notificationId, noti, projectName, taskName, meetingName, startTime, roomId, typeId, notificationType){
        let route = ''
        let url = `/api/v1/meetings/item?companyId=${companyId}&parentId=${projectId}&meetingId=${meetingId}&taskId=${taskId}&typeId=${typeId}`;
        switch (typeId) {
          case 1:
          case 4:
            route = 'projects'
            break;
          case 2:
          case 5:
            route = 'business-units'
            break;
          case 3:
          case 6:
            route = 'engagements'
            break;
        }

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(url)
        loader.hide()

        if (data.item.statusUser === null) {
          return this.openUserWithoutStatusModal(notificationId)
        }

        // check if project or task selected
        let msg = '';
        if (taskName) {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div><div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p')}${projectName}</div><div>${this.$i18n.t('header_approveMeeting_task')} ${taskName}</div><div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div><div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomId}</div><div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTime, 'X').format('D MMM YY, h:mm a')}</div><div>${this.$i18n.t('header_approveMeeting_userStatus')}: <span class="user-status-${data.item.statusUser}">${this.$i18n.t(`header_approveMeeting_userStatus_${data.item.statusUser}`)}</span></div>`;
        } else {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div><div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : (route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p'))}${projectName}</div><div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div><div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomId}</div><div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTime, 'X').format('D MMM YY, h:mm a')}</div><div>${this.$i18n.t('header_approveMeeting_userStatus')}: <span class="user-status-${data.item.statusUser}">${this.$i18n.t(`header_approveMeeting_userStatus_${data.item.statusUser}`)}</span></div>`;
        }
        this.$confirm(msg, this.$t('header_meetingInvite'), {
          confirmButtonText: this.$t('header_viewMeeting'),
          dangerouslyUseHTMLString: true,
          callback: action => {
            if (action === 'confirm') {
              this.checkIfCompanySelected(companyId, projectId, taskId, meetingId, companyName, notificationId, noti, route, notificationType)
            }
          }
        })
      },
      openUserWithoutStatusModal(notificationId) {
        this.$alert(this.$i18n.t('modal_notifications_thisWillPermanentlyDeleteTheNotificationContinue'), this.$i18n.t('header_approveMeeting_youWasDeletedFromSelectedMeeting'), {
          confirmButtonText: this.$t('general_ok'),
          callback: action => {
            if (action === 'confirm') {
              this.removeNotification(notificationId)
            }
          }
        });
      },
      openModalMeetingReminder(companyId, parentId, taskId, meetingId, companyName, meetingAction, route, parentName, taskName, meetingName, startTimestamp, action, roomId) {
        // check if project or task selected
        let msg = '';
        if (taskName) {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p')}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_task')} ${taskName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomId}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meetingWillStartIn5Minutes')}</div>`;
        } else {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : (route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p'))}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomId}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meetingWillStartIn5Minutes')}</div>`;
        }
        this.$confirm(msg, this.$t('header_meetingStarting'), {
          confirmButtonText: this.$t('header_goToMeeting'),
          cancelButtonText: this.$t('general_cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.checkIfCompanySelected(companyId, parentId, taskId, meetingId, companyName, null, meetingAction, route, 5)
            }
          }
        })
      },
      openModalStartMeeting(companyId, parentId, taskId, meetingId, companyName, route, parentName, taskName, meetingName, startTimestamp, roomVideoId, typeId){
        // check if project or task selected
        let msg = '';
        if (taskName) {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p')}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_task')} ${taskName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>`;
        } else {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : (route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p'))}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>`;
        }
        this.$confirm(msg, this.$t('header_meeting') + ' "' + roomVideoId + '" ' + this.$t('header_meeting_isStartedJoinMeetingNow'), {
          confirmButtonText: this.$t('header_goToMeeting'),
          cancelButtonText: this.$t('general_cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              let myTypeId = null
              let typeName = null
              switch (typeId) {
                case 1:
                  myTypeId = parentId
                  typeName = 'project'
                  break;
                case 2:
                  myTypeId = parentId
                  typeName = 'businessUnit'
                  break;
                case 3:
                  myTypeId = parentId
                  typeName = 'engagement'
                  break;
                case 4:
                  myTypeId = taskId
                  typeName = 'projectTask'
                  break;
                case 5:
                  myTypeId = taskId
                  typeName = 'businessUnitTask'
                  break;
                case 6:
                  myTypeId = taskId
                  typeName = 'engagementTask'
                  break;
              }

              if (this.$route.query.companyId.toString() === companyId.toString()) {
                if (this.$route.name === 'projects' && this.$route.query.projectId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'projects' && this.$route.query.projectId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString() ||
                    this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString() ||
                    this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString()
                ) {
                  this.$store.dispatch('getMeetings', {
                    companyId: companyId,
                    parentId: parentId,
                    taskId: taskId,
                    typeId: typeId})
                }
              }
              this.goToMeeting(meetingId, myTypeId, companyId, typeName)
            }
          }
        })
      },
      openModalStartHostMeeting(companyId, parentId, taskId, meetingId, companyName, route, parentName, taskName, meetingName, startTimestamp, roomVideoId, typeId){
        // check if project or task selected
        let msg = '';
        if (taskName) {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p')}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_task')} ${taskName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomVideoId}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>`;
        } else {
          msg = `<div>${this.$i18n.t('header_approveMeeting_company')}: ${companyName}</div>
                 <div>${route === 'engagements' ? this.$i18n.t('header_approveMeeting_e') : (route === 'business-units' ? this.$i18n.t('header_approveMeeting_bu') : this.$i18n.t('header_approveMeeting_p'))}${parentName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_meeting')} ${meetingName}</div>
                 <div>${this.$i18n.t('header_approveMeeting_roomId')}: ${roomVideoId}</div>
                 <div>${this.$i18n.t('header_approveMeeting_start')} ${moment(startTimestamp, 'X').format('D MMM YY, h:mm a')}</div>`;
        }
        this.$confirm(msg, this.$t('header_meeting') + ' "' + roomVideoId + '" ' + this.$t('header_meeting_isStarted'), {
          confirmButtonText: this.$t('header_startMeeting'),
          cancelButtonText: this.$t('general_cancel'),
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.startHostMeeting(companyId, parentId, taskId, meetingId, route, startTimestamp, typeId)
            }
          }
        })
      },
      startHostMeeting(companyId, parentId, taskId, meetingId, route, startTimestamp, typeId) {
        const isLater = startTimestamp < moment().format('X')
        let myUrl = `/api/v1/meetings/start?companyId=${companyId}&parentId=${parentId}&taskId=${taskId}&meetingId=${meetingId}&isLater=${isLater}&typeId=${typeId}`
        let typeName = ''
        switch (typeId) {
          case 1:
            typeName = 'project'
            break;
          case 2:
            typeName = 'projectTask'
            break;
          case 3:
            typeName = 'businessUnit'
            break;
          case 4:
            typeName = 'businessUnitTask'
            break;
          case 5:
            typeName = 'engagement'
            break;
          case 6:
            typeName = 'engagementTask'
            break;
        }
        // project
        // if (route === 'projects' && !taskId) {
        //   myUrl = `/api/v1/projectMeetings/start?companyId=${companyId}&projectId=${parentId}&projectMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'project'
        // }
        // // project task
        // if (route === 'projects' && taskId) {
        //   myUrl = `/api/v1/projectTaskMeetings/start?companyId=${companyId}&projectId=${parentId}&projectTaskId=${taskId}&projectTaskMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'projectTask'
        // }
        // // business unit
        // if (route === 'business-units' && !taskId) {
        //   myUrl = `/api/v1/businessUnitMeetings/start?companyId=${companyId}&businessUnitId=${parentId}&businessUnitMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'businessUnit'
        // }
        // // business unit task
        // if (route === 'business-units' && taskId) {
        //   myUrl = `/api/v1/businessUnitTaskMeetings/start?companyId=${companyId}&businessUnitId=${parentId}&businessUnitTaskId=${taskId}&businessUnitTaskMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'projectTask'
        // }
        // // engagement
        // if (route === 'engagements' && !taskId) {
        //   myUrl = `/api/v1/engagementMeetings/start?companyId=${companyId}&engagementId=${parentId}&engagementMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'engagement'
        // }
        // // engagement task
        // if (route === 'engagements' && taskId) {
        //   myUrl = `/api/v1/engagementTaskMeetings/start?companyId=${companyId}&engagementId=${parentId}&engagementTaskId=${taskId}&engagementTaskMeetingId=${meetingId}&isLater=${isLater}`
        //   typeName = 'engagementTask'
        // }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(myUrl)
            .then(response => {
              this.goToMeeting(meetingId, taskId || parentId, companyId, typeName)
              if (this.$route.query.companyId.toString() === companyId.toString()) {
                if (this.$route.name === 'projects' && this.$route.query.projectId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'projects' && this.$route.query.projectId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString() ||
                    this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'business-units' && this.$route.query.businessUnitId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString() ||
                    this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === parentId.toString() && this.$route.query.taskId.toString() === '0'  && !taskId ||
                    this.$route.name === 'engagements' && this.$route.query.engagemenetId.toString() === parentId.toString() && this.$route.query.taskId.toString() === taskId.toString()
                ) {
                  this.$store.dispatch('getMeetings', {
                    companyId: this.$route.query.companyId,
                    parentId: parentId,
                    taskId: taskId,
                    typeId: typeId})
                }
              }
            })
            .catch(error => {
              console.log('An error occurred:', error);
            })
      },
      goToMeeting(meetingId, typeId, companyId, typeName) {
        // this.$router.push(`/meetings?companyId=${this.$route.query.companyId}&token=${sessionStorage.getItem('token')}&mName=`)
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/videoChat/checkUser?companyId=${companyId}&meetingId=${meetingId}`)
            .then(response => {
              console.log(response)
              loader.hide()
              let routeData = this.$router.resolve({name: 'meetings',
                query: {
                  companyId: companyId,
                  meetingId: meetingId,
                  typeId: typeId,
                  typeName: typeName,
                  token: sessionStorage.getItem('token'),
                  roomId: response.data.roomId
                }
              });
              window.open(routeData.href, '_blank');
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      checkIfTaskShared(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route){
        return new Promise((resolve, reject) => {
          console.log(companyId, projectId, taskId, stateId, companyName, notificationId, noti, route);
          // let url = '';
          switch (route) {
            case 'business-units':
                // url = `/api/v1/notifications/ifShared?companyId=${companyId}&businessUnitId=${projectId}&businessUnitTaskId=${taskId}`;
              resolve({
                companyId: companyId,
                parentId: projectId,
                taskId: taskId,
                ifShare: false,
                stateId: stateId,
                companyName: companyName,
                notificationId: notificationId,
                noti: noti,
                route: route
              });
              break;
            case 'engagements':
              // url = `/api/v1/notifications/ifShared?companyId=${companyId}&engagementId=${projectId}&engagementTaskId=${taskId}`;
              resolve({
                companyId: companyId,
                parentId: projectId,
                taskId: taskId,
                ifShare: false,
                stateId: stateId,
                companyName: companyName,
                notificationId: notificationId,
                noti: noti,
                route: route
              });
              break;
            case 'projects':
              // CHECK FOR TASK ONLY
              if (taskId) {
                let loader = this.$loading.show();
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                  .get(`/api/v1/notifications/ifShared?companyId=${companyId}&projectId=${projectId}&projectTaskId=${taskId}`)
                  .then(response => {
                    const data = {
                      companyId: response.data.newNotifData.companyId,
                      parentId: response.data.newNotifData.projectId,
                      taskId: response.data.newNotifData.projectTaskId,
                      ifShare: response.data.newNotifData.ifShare,
                      stateId: stateId,
                      companyName: response.data.newNotifData.companyName,
                      notificationId: notificationId,
                      noti: noti,
                      route: response.data.newNotifData.ifShare ? 'shared-projects' : route
                    };
                    loader.hide();
                    resolve(data)
                  })
                  .catch(error => {
                    loader.hide();
                    console.log('An error occurred:', error);
                    reject(error)
                  });
              } else {
                resolve({
                  companyId: companyId,
                  parentId: projectId,
                  taskId: taskId,
                  ifShare: false,
                  stateId: stateId,
                  companyName: companyName,
                  notificationId: notificationId,
                  noti: noti,
                  route: route
                });
              }
              break
          }
        });
      },
      toggleNavDrawer() {
        console.log('ddddd', this.$route)
        this.$store.dispatch('toggleSideBar');
        if (this.sidebarOpened) {
          // this.menu = false
          this.$emit('showMenu');
          this.$store.dispatch('getMenuStatistics');

          // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          // axios.post(`/api/v1/news/list`)
          //   .then(response => {
          //     console.log('---/news/list', response.data.list);
          //   })
          //   .catch(error => {

          //   });

          this.$store.dispatch('getNewsMenu', localStorage.getItem('lang'));

        } else {
          // this.menu = true
          this.$emit('hideMenu');
        }
        // console.log('---M', this.menu)
        // this.$store.dispatch('getMenuStatistics');
      },
      TEST(){
        console.log("TEST1")
        this.$options.sockets.notification = (data) => {
          // this.$message('You have a message.', data)
        }
      },
      getProjectStages() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyStages/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            console.log('---', response.data);
            this.stages = response.data.list
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      TEST2(){
        console.log("TEST2")
        this.$socket.emit('message', {0:"login"});
      },
      exit() {
        this.$socket.close()
        localStorage.clear()
        this.$router.push({name: 'login'})
      },
      showModalInviteCompany() {
        console.log('---', 'open');
        this.$refs.company.open()
      },
      async setCompany(companie) {
        try {
          let loader = this.$loading.show();

          if (this.$route.query.companyId.toString() === companie.id.toString()){
            return loader.hide()
          }

          await this.$store.dispatch('companyChange', companie.id);

          await this.$store.dispatch('toggleActiveCompanyName', companie.name);

          localStorage.setItem('companyId', companie.id);
          if (localStorage.getItem('selectedProjectId')){
            localStorage.removeItem('selectedProjectId')
          }
          if (localStorage.getItem('selectedEngagementId')){
            localStorage.removeItem('selectedEngagementId')
          }
          if (localStorage.getItem('selectedBusinessUnitId')){
            localStorage.removeItem('selectedBusinessUnitId')
          }
          const companyLayout = await this.$store.dispatch('getCompanyLayout', companie.id);

          const data = {
            companyId: companie.id,
            companyUserId: companyLayout.companyUserId
          };

          this.$socket.emit('companyChanged', data);

          if(companyLayout.lastProjectId !== null){
            localStorage.setItem('selectedProjectId', companyLayout.lastProjectId);
            await this.$router.replace(`projects?companyId=${companie.id}&projectId=${companyLayout.lastProjectId}`);
            this.rerenderMainLayout();
          }else{
            await this.$router.replace(`projects?companyId=${companie.id}`);
            this.rerenderMainLayout();
          }

          // close chat if it open
          if(this.$refs.chat2.list){
            this.$refs.chat2.list = false
          }

          loader.hide()
        } catch (err){
          console.log(err)
        }
      },
      // setCompanyId(id, name) {
      //   localStorage.setItem('companyId', id);
      //   localStorage.setItem('companyName', name);
      //   // this.$emit('setCompany')
      //
      //   console.log('---PAGE', this.$route.name)
      //   switch (this.$route.name) {
      //     case 'projects':
      //       this.$store.dispatch('getMenuStatistics');
      //       this.$emit('setCompany')
      //       break;
      //     case 'business-units':
      //       this.$store.dispatch('getMenuStatistics');
      //       this.$emit('setCompany')
      //       break;
      //     case 'shared-projects':
      //       this.$store.dispatch('getMenuStatistics');
      //       break;
      //     case 'users':
      //       this.$store.dispatch('getMenuStatistics');
      //       this.$store.dispatch('getRowDataUsers');
      //       break;
      //     case 'clients':
      //       this.$store.dispatch('getMenuStatistics');
      //       this.$store.dispatch('getRowDataClients');
      //       // Clear rowDataClientsPerson
      //       this.$store.dispatch('getRowDataClientsPersonClear');
      //       break;
      //     case 'vendors':
      //       this.$store.dispatch('getMenuStatistics');
      //       this.$store.dispatch('getRowDataVendors');
      //       // Clear rowDataVendorsPerson
      //       this.$store.dispatch('getRowDataVendorsPersonClear');
      //       break;
      //     case 'partners':
      //       this.$store.dispatch('getMenuStatistics');
      //       break;
      //   }
      //   localStorage.removeItem('selectedProjectId');
      // },
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post('/api/v1/companies/create', {
                name: this.form.companyName,
                email: this.form.email,
                companyType: 0
              })
              .then(response => {
                console.log('---', response.data);
                this.$refs.company.close();
                this.notification("Success", "Create company", "success");
                this.refreshUser();
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          dangerouslyUseHTMLString: true,
          message: message,
          type: type,
          customClass:"message-notification"
        });
      },
      // notificationDisc(title, message, type, duration) {
      //   this.$notify({
      //     title: title,
      //     message: message,
      //     type: type,
      //     duration: duration || 0
      //   });
      // },
      refreshUser(){
        this.$store.dispatch('loadUser')
      },
      myProfile() {
        this.$refs['modal'].$refs['myProfile'].open()
      },
      goToCompanies(){
        if(this.$route.query.companyId){
          this.$router.push(`/settings?companyId=${this.$route.query.companyId}`)
        }else{
          this.$router.push(`/settings`)
        }
      },
      // hideNoti(){
      //   console.log('route', this.$route)
      //   console.log('router', this.$router)
      // },
      goToSettings(){
        // alert('hello')
      },
      refreshExpensePage(){
        this.$emit('refreshExpensePageFromHeader')
      },
      refreshUserPage(){
        this.$emit('refreshUserExpensePageFromHeader')
      },
      refreshCashAdvancePage(){
        this.$emit('refreshCashAdvanceFromHeader')
      },
      // isExitClick(){
      //   this.varIsExitClick = true
      //   this.notificationDisc("Error", "Connection Lost.", "error", 2000)
      // }
      async selectCreatedTaskInSameParent(taskId, notificationType, stateId) {
        try {

          const selectedTab = await this.$emit('setActiveTabs', notificationType, stateId);

          const selectedNode = await this.$emit('selectCreatedTask', taskId);

        } catch (err) {
          console.log(err)
        }
      },
      rerenderMainLayout(){
         this.$emit('rerenderMainLayout')
      },
      removeNotificationOpenModal(notificationId){
        this.$confirm(this.$t('modal_notifications_thisWillPermanentlyDeleteTheNotificationContinue'), this.$t('modal_notifications_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          this.removeNotification(notificationId);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      async setHelpVisible(value) {
        if (value) {
          let loader = this.$loading.show();
          const route = this.$route.name === 'cash-receipts' ? 'cash_receipts' : 'cash_disbursements'
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            const { data } = await axios.post(`/api/v1/helpers/get?type=child&id=null&parentKey=${route}`)
            this.helpList = data.result
            loader.hide()
            return true
          } catch (err) {
            console.log('err', err)
            loader.hide()
          }
        } else {
          this.helpList = []
        }
      },
      setHelp(item) {
        console.log('heeeeelp')
        this.helpItem = item
        this.$refs.helpModal.open()
      },
      setWorkday(command){
        switch (command) {
          case 'project':
            if (this.$route.name === 'projects') this.$emit('setWorkDay');

            else {
              localStorage.setItem('isWorkDay', 'workDayOpen');
              this.$router.push({name: 'projects', query: {companyId: this.$route.query.companyId}})
            }

            break;
          case 'businessUnit':
            if (this.$route.name === 'business-units') this.$emit('setWorkDay');

            else {
              localStorage.setItem('isWorkDay', 'workDayOpen');
              this.$router.push({name: 'business-units', query: {companyId: this.$route.query.companyId}})
            }

            break;
          case 'engagement':
            if (this.$route.name === 'engagements') this.$emit('setWorkDay');

            else {
              localStorage.setItem('isWorkDay', 'workDayOpen');
              this.$router.push({name: 'engagements', query: {companyId: this.$route.query.companyId}})
            }

            break;
        }
      },
      // getValidUrl(url) {
      //   let newUrl = window.decodeURIComponent(url)
      //   newUrl = newUrl.trim().replace(/\s/g, '')
      //
      //   if (/^(:\/\/)/.test(newUrl)) {
      //     return `http${newUrl}`
      //   }
      //   if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
      //     return `http://${newUrl}`
      //   }
      //
      //   return newUrl
      // },
      setProgressNotificationImg(action) {
        switch (action){
          case 'createProjectTaskProgress':
          case 'createEngagementTaskProgress':
          case 'createBusinessUnitTaskProgress':
            return require('@/assets/img/icons/bdg_create.svg')
          case 'doneProjectTask':
          case 'doneEngagementTask':
          case 'doneBusinessUnitTask':
            return require('@/assets/img/icons/bdg_done.svg')
          case 'startProjectTask':
          case 'startEngagementTask':
          case 'startBusinessUnitTask':
            return require('@/assets/img/icons/bdg_start.svg')
          case 'holdProjectTask':
          case 'holdEngagementTask':
          case 'holdBusinessUnitTask':
            return require('@/assets/img/icons/bdg_hold.svg')
          case 'restartProjectTask':
          case 'restartEngagementTask':
          case 'restartBusinessUnitTask':
            return require('@/assets/img/icons/bdg_restart.svg')
          case 'updateProjectTaskProgress':
          case 'updateBusinessUnitTaskProgress':
          case 'updateEngagementTaskProgress':
            return require('@/assets/img/icons/edited.svg')
          case 'createProjectTaskProgressRemark':
          case 'createBusinessUnitTaskProgressRemark':
          case 'createEngagementTaskProgressRemark':
            return require('@/assets/img/icons/icn_remark.svg')
          default:
            return require('@/assets/img/icons/icn_remark.svg')
        }
      }
    },
    beforeDestroy(){
      console.log("DESTROY ХЕДЕР");
      console.log('this', this)
      // this.notificationDisc("Error", "Connection Lost.", "error", 1000)
    },
    watch:{
      '$route'(to, old) {
         if(to.name === 'invite-user' || to.name === 'confirm-email' || to.name === 'reset' || to.name === 'reset-password-confirm' || to.name === 'signup' || to.name === 'login' || old.name === 'companies'){
            if(this.$refs.chat2.list){
               this.$refs.chat2.list = false
            }
         }
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.el-button--small, .el-button--small.is-round {
    background: #DFE8F0;
    color: #4277A6;
    border: none;
    padding: 5px 5px;
  }
  /deep/.el-button:hover {
    // background: #E8F0F7;
    // color: #4277A6;
    // border: 1px solid #4277A6;

    animation: glow 800ms ease-out infinite alternate;
    background: #fff;
    border-color: #393;
    box-shadow: 0 0 7px rgba(255, 240, 160, .2), inset 0 0 7px rgba(255, 240, 160, .2);
    color: #4277A6;
    outline: none;
  }
    .header {
        /*margin-top:50px;*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 50px;
        position: fixed;
        width: 100%;
        height: 50px;
        // background: #141b25;
        // color: white;
        background: #EFF4F8;
        color: 4277A6;
        z-index: 999;
        .company {
            display: flex;
            align-items: center;
            width: 100%;
            margin: 0 10px;
            &__name {

            }
            .warning-icon {
              color: #F56C73;
              cursor: pointer;
              font-size: 20px;
              margin-left: 10px;
              cursor: pointer;
            }
            &__create {
                margin-right: 10px;
            }
            .logo_img {
                margin-right: 20px;
            }
            a {
                display: inline-block;
            }
            // Menu
            .hamburger {
                min-width: 23px;
                height: 23px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                /*margin-right: 20px;*/
                cursor: pointer;
                &__item {
                    height: 2px;
                    background: #4277A6;
                }
            }

            .logo {
                display: flex;
                align-items: center;
                margin-right: 5px;
                img {
                    margin-right: 0;
                }
            }

            // Menu close
            #close {
                position: relative;
                min-width: 23px;
                height: 23px;
                /*margin-right: 20px;*/
                cursor: pointer;
                // background: #ccc;
            }
            .close {
                position: absolute;
                left: 0;
                top: 0;
                width: 23px;
                height: 23px;
                color: #4277A6;
            }
            .close:hover {
                opacity: 1;
            }
            .close:before, .close:after {
                position: absolute;
                top: -2px;
                left: 10px;
                content: ' ';
                height: 27px;
                width: 2px;
                background-color: #4277A6;
            }
            .close:before {
                transform: rotate(45deg);
            }
            .close:after {
                transform: rotate(-45deg);
            }
        }
        .my-workday {
            margin-right: 10px;
            display: flex;
            align-items: center;
            background: #DFE8F0;
            color: #4277A6;
            border-radius: 3px;
            padding: 5px;
            cursor: pointer;
            white-space: nowrap;
            font-size: 14px;
            &:hover {
                animation: glow 800ms ease-out infinite alternate;
                background: #fff;
                border-color: #393;
                box-shadow: 0 0 7px rgba(255, 240, 160, .2), inset 0 0 7px rgba(255, 240, 160, .2);
                color: #4277A6;
                outline: none;
            }
        }
        .my-lists{
            display:flex;
            margin-right: 39px;
        }
        .notification {
            display: flex;
            margin-right: 10px;
            .full {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 20px 0;
                cursor: pointer;
            }
            &__item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 35px;
                height: 35px;
                color: white;
                border-radius: 3px;
                margin-right: 3px;
                cursor: pointer;
                // &:hover {
                //   .el-button {
                //     background: #409EFF;
                //     color: white;
                //   }
                // }
            }
            .with-badge{
                position:relative;
                .el-badge{
                    position:absolute;
                    top:-6px;
                    right: -6px;
                    z-index:1;
                }
            }
            &__item:last-child {
                margin-right: 0;
            }
            .red:hover {
                .el-button {
                    background: #ff2a2a;
                    color: white;
                }
            }
            &__q {
                display: flex;
                margin-left: 0;
            }
        }
    }
    .box {
        &:hover {
            background: #f7f7f7;
        }
    }
    .timer-title {
      display: flex;
      justify-content: space-between;
      padding: 5px 8px 0 8px;
      font-weight: bold;
      color: #409EFF;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .title {
        display: flex;
        justify-content: space-between;
        padding: 5px 8px 0 8px;
        font-weight: bold;
        &__time {
            font-weight: normal;
            margin-right: 25px;
        }
    }
    .timer {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 5px 8px;
        border-bottom: 1px dashed #d9d9d9;
        &__btn {
            margin-left: auto;
        }
    }
    .tasks-dropdown{
        display:flex;
        justify-content:space-between;
    }
    .mark-as-read{
        /*float: right;*/
        /*margin-right: 20px;*/
        /*margin-top: 20px;*/
    }
    .invite-modal{
        color:black;
    }
    .share-task-modal{
        color:black;
    }
    .drop-down-head{
        font-weight:bold;
        text-align:center;
    }
    .drop-down-head-general{
        padding:0 20px;
        cursor: default;
        color: #bbb;
        pointer-events: none;
        font-size: 14px;
        line-height: 36px;
        &_header{
            display:flex;
            justify-content:center;
        }
    }
    .parent-notification-tabs {
      /deep/.el-tabs__nav {
        width: 100%;
        #tab-businessUnits,#tab-engagements,#tab-projects {
          padding: 0 !important;
        }
      }
    }
    /deep/.notification-tabs{
        height:50px;
        .el-tabs__header{
            margin-bottom:0;
        }
        .el-tabs__nav-scroll{
            display:flex;
            justify-content:center;
        }
    }
    .sub-title{
        display:flex;
        justify-content: space-around;
        font-weight:bold;
    }
    .line-select{
        /*line-height: 30px;*/
        display:flex;
    }
    .line-select-general {
        display:flex;
        align-items:center;
        justify-content: space-between;
        .text-truncate-general-date{
            min-width: 60px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        //.text-truncate-general-action{
        //    min-width:calc(100% - 190px);
        //    white-space: nowrap;
        //    overflow: hidden;
        //    text-overflow: ellipsis;
        //}
        .close-btn {
            width: 20px;
            display: flex;
            align-items: center;
            height: 20px;
            justify-content: center;
            /deep/.el-icon-close{
                  margin:0;
            }
        }
    }
    .line-select-bookmarks{
      display:flex;
      align-items:center;
      justify-content: space-between;
      .close-btn {
        width: 20px;
        display: flex;
        align-items: center;
        height: 20px;
        justify-content: center;
        /deep/.el-icon-close{
          margin:0;
        }
      }
    }
    .empty-head{
        text-align:center;
    }
    // [ Modal style ] start ---
    .modal {
        color: black;
        .modal__btn {
            margin-top: 20px;
        }
    }
    // [ Modal style ] end   ---
    .el-dropdown-menu{
        /*min-width:390px;*/
        width:390px;
        max-height: none;
        position:relative;
        z-index:2;
        overflow:visible;
        .project-task-tabs{
            z-index:0;
            position:absolute;
            right:380px;
            top:52px;
            background-color:#FFF;
        }
        &>div{
            max-height: 500px;
            overflow-x: hidden;
        }
    }
    /*#general{*/
    /*width: 650px;*/
    /*}*/
    .switch-btn{
        margin-right:20px;
    }
    .company__name{
      display: flex;
      background: #DFE8F0;
      color: #4277A6;
      border-radius: 3px;
      padding: 5px;
      &:hover {
        animation: glow 800ms ease-out infinite alternate;
        background: #fff;
        border-color: #393;
        box-shadow: 0 0 7px rgba(255, 240, 160, .2), inset 0 0 7px rgba(255, 240, 160, .2);
        color: #4277A6;
        outline: none;
      }
    }
    .timer-link{
        cursor:pointer;
        color:#409EFF;
      &.task-name {
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .general-tool-tip{
        left:-300px;
        &_content{
            line-height: 1.5;
            font-size:14px;
        }
    }
    .text-truncate{
        min-width:calc(50% - 90px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-truncate-doc{
        min-width:calc(33% - 30px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-truncate-bookmark{
        width:50%;
        //padding: 0 5px;
        //min-width:50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-icon-star-on{
        font-size:14px;
    }

    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #000;
      margin-right: 10px;
      &__green {
        background: #67C23A;
      }
      &__grey {
        background: #909399;
      }
    }
    .unchecked-item {
        font-weight:bold;
        color: black;
    }
    .tasks-parent-name {
      text-decoration: underline;
      margin-bottom: 5px;
      text-transform: uppercase;
      line-height: 24px;
    }
    .tasks-task-name {
      line-height: 24px;
    }
</style>

<style lang="scss">
  .ql-tooltip {
    left: 10px !important;
  }
  .el-message-box__message {
    .user-status-approved{
      color: #67c23a;
    }
    .user-status-invite {
      color: #409eff;
    }
    .user-status-host {
      color: #409eff;
    }
    .user-status-decline {
      color: #f56c6c;
    }
    .user-status-maybe {
      color: #e6a23c;
    }
  }
</style>

